import React, { useMemo, useRef, useState, useEffect } from "react";
import {
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  GuestCard,
  Input,
  ListHolder,
  MediumFont,
  PlaceHolderImage,
  PopupDiv,
  RespFont,
  TableCard,
  TextWithPic,
} from "../../common/Style";
import { useDispatch, useSelector } from "react-redux";
import manStand from "./manStand.png";
import undo from "./undo.svg";
import sideTable from "../../../assets/common/sideTable.svg";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import checklist from "../../../assets/common/checklist.svg";
import menu from "../../../assets/common/menu.svg";
import manSeat from "./manSeat.png";
import spinner from "../../../assets/common/spinner.svg";
import clear from "../../../assets/common/clear.svg";
import guestsP from "../../../assets/common/closenessS2.svg";

import notes from "../../../assets/common/notes.svg";
import {
  addAlpha,
  getImageUrl,
  handleClickScroll,
} from "../../common/others/Functions";
import AddTables from "./AddTables";
import GenericModal from "../../common/modals/GenericModal";
import EditTables from "./EditTables";
import DeleteTables from "./DeleteTables";
import TheadTables from "./TheadTables";
import TrTables from "./TrTables";
import ToolsOptions from "../ToolsOptions";
import { toast } from "react-toastify";
import { editMany, getAll } from "../../../store/reducers/guestsReducer";
import OpacityLoading from "../../common/loader/OpacityLoading";
import EditPics from "../../common/others/EditPics";
import { deletePhoto } from "../../../store/reducers/photosReducer";
import { checkAuth, editDetails } from "../../../store/reducers/authReducer";
import { UseInterval } from "../../common/others/UseInterval";
import SmallLoading from "../../common/loader/SmallLoading";
import AddG2T from "./AddG2T";
import styled from "styled-components";
import {
  add,
  deleteF,
  getAllH,
  cleanAll,
} from "../../../store/reducers/helpersReducer";

// CSS animation להבהוב
const blinkAnimation = `
  @keyframes blink {
    0% { 
      opacity: 1; 
      transform: scale(1);
      box-shadow: 0 0 25px rgba(255, 0, 0, 0.9);
    }
    50% { 
      opacity: 0.6; 
      transform: scale(1.08);
      box-shadow: 0 0 35px rgba(255, 0, 0, 1);
    }
    100% { 
      opacity: 1; 
      transform: scale(1);
      box-shadow: 0 0 25px rgba(255, 0, 0, 0.9);
    }
  }
`;

// CSS animation לתפריט
const slideInAnimation = `
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// הוספת ה-CSS ל-head
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = blinkAnimation + slideInAnimation;
  document.head.appendChild(style);
}

let multyChoise = {};
let multyChoiseCounter = 0;

// קומפוננט מודל ללא רקע מטושטש
const ClearModal = ({ div, init }) => {
  return (
    <div
      style={{
        display: "flex",
        overflow: "auto",
        width: "100%",
        margin: "0 auto",
        position: "fixed",
        minHeight: "100vh",
        height: "100%",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        top: "0px",
        left: "0px",
        zIndex: 9999,
        background: "rgba(0, 0, 0, 0.8)",
      }}
      onClick={init}
    >
      <div onClick={(e) => e.stopPropagation()}>{div}</div>
    </div>
  );
};

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
}) => {
  return (
    <div
      style={{
        position: position,
        zIndex: 1000,
        ...(top && { top }),
        ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#5377bb",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "8px",
          cursor: "pointer",
          fontSize: 14,
          width: "36px",
          height: "36px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
        }}
        title="תפריט"
      >
        <div
          style={{
            width: "16px",
            height: "2px",
            background: "white",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-5px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "white",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "5px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "white",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            animation: "slideIn 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#5377bb",
  disabled = false,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disabled={disabled}
      style={{
        background: "transparent",
        color: disabled ? "#999" : "#333",
        border: "none",
        borderRadius: "8px",
        padding: "12px 16px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: 14,
        width: "100%",
        textAlign: "right",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        transition: "all 0.2s ease",
        marginBottom: "4px",
        ":hover": {
          background: disabled ? "transparent" : "#f5f5f5",
        },
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.background = "#f5f5f5";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "transparent";
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: disabled ? "#999" : color,
        }}
      >
        {icon}
      </div>
      {text}
    </button>
  );
};

const MainTables = ({ init, handleGetAll }) => {
  const dispatch = useDispatch();

  const { user, isTal } = useSelector((state) => state.authReducer);
  const { helpers } = useSelector((state) => state.helpersReducer);
  const { guests, guestsLoading } = useSelector((state) => state.guestsReducer);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const inputRef = useRef();
  const [table, setTable] = useState(null);
  const [what2show, setWhat2show] = useState(isTal ? "הושבתי" : "נותרו");
  const [cats, setCats] = useState();
  const [multiSelect, setMultiSelect] = useState(false);
  const [addTables, setAddTables] = useState(false);
  const [editTables, setEditTables] = useState(false);

  const [scetchSize, setScetchSize] = useState(1000);

  const handleEditTables = () => {
    setShowTableArrange(false);
    setEditTables(false);
  };
  const [deleteTables, setDeleteTables] = useState(false);
  const [selected, setSelected] = useState(0);
  const [closenessChosenFlag, setClosenessChosenFlag] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [editSketch, setEditSketch] = useState(false);
  const [showSketch, setShowSketch] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [title, setTitle] = useState(user.seatupEventId == "besimple");
  const [reception, setReception] = useState(true);
  const [showAddGuest, setShowAddGuest] = useState(false);
  const [flag, setFlag] = useState(false);
  const [showTableArrange, setShowTableArrange] = useState(false);
  const [draggedTable, setDraggedTable] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [resizeTable, setResizeTable] = useState(null);
  const [resizeStart, setResizeStart] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const [rotateTable, setRotateTable] = useState(null);
  const [rotateStart, setRotateStart] = useState({
    x: 0,
    y: 0,
    angle: 0,
  });
  const [tablesPositions, setTablesPositions] = useState(() =>
    user.tablesArray.map((table) => ({
      x: table.x ?? 20,
      y: table.y ?? 80,
      width: table.width ?? 60,
      height: table.height ?? 60,
      shape: table.shape ?? "square", // Default to square
      rotation: table.rotation ?? 0, // Default rotation is 0 degrees
    }))
  );
  const [showTableGuests, setShowTableGuests] = useState(false);
  const [tableGuestsData, setTableGuestsData] = useState({
    title: "",
    guests: [],
    tableNumber: null,
  });

  const GRID_SIZE = 20;

  const [helperElements, setHelperElements] = useState(() => {
    // Initialize from user.tables or use empty object
    const savedHelpers = user.tables?.helpers || {};

    // Add fontSize and rotation to existing helpers that don't have it
    const helpersWithFontSize = {};
    Object.entries(savedHelpers).forEach(([key, helper]) => {
      helpersWithFontSize[key] = {
        ...helper,
        fontSize: helper.fontSize || 12, // Default fontSize for existing helpers
        rotation: helper.rotation || 0, // Default rotation for existing helpers
      };
    });

    return helpersWithFontSize;
  });
  const [draggedHelper, setDraggedHelper] = useState(null);
  const [resizeHelper, setResizeHelper] = useState(null);
  const [rotateHelper, setRotateHelper] = useState(null);
  const [showHelperModal, setShowHelperModal] = useState(false);
  const [editingHelper, setEditingHelper] = useState(null);
  const [newHelperTitle, setNewHelperTitle] = useState("");
  const [newHelperColor, setNewHelperColor] = useState("#4c6daf");
  const [newHelperBgColor, setNewHelperBgColor] = useState("#e0e8f6");
  const [newHelperTextAlign, setNewHelperTextAlign] = useState("center");
  const [newHelperFontSize, setNewHelperFontSize] = useState(18);
  const [zoomLevel, setZoomLevel] = useState(() => {
    // Initialize from user.tables or use default 1 (100%)
    return user.tables?.zoomLevel || 0.7;
  });

  // Add state for editing table number
  const [editingTableNumberIdx, setEditingTableNumberIdx] = useState(null);
  const [editingTableNumberValue, setEditingTableNumberValue] = useState("");

  // Add state for background display
  const [showSketchBackground, setShowSketchBackground] = useState(false);
  const [showGuestsList, setShowGuestsList] = useState(true);

  // Add state for table lock
  const [tablesLocked, setTablesLocked] = useState(true);

  // Add state for view mode (when showing guests)
  const [viewMode, setViewMode] = useState(false);
  const [blinkingTables, setBlinkingTables] = useState([]);
  const [markedTables, setMarkedTables] = useState([]);
  const [savedHelperSets, setSavedHelperSets] = useState([]);
  const [showSavedSetsModal, setShowSavedSetsModal] = useState(false);
  const [customSetName, setCustomSetName] = useState("");
  const [showNameInput, setShowNameInput] = useState(false);
  const [showTableSelectionModal, setShowTableSelectionModal] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);
  const [currentTableForSelection, setCurrentTableForSelection] =
    useState(null);
  const [showTableContextMenu, setShowTableContextMenu] = useState(false);
  const [showRangesModal, setShowRangesModal] = useState(false);
  const [showSwapTablesModal, setShowSwapTablesModal] = useState(false);
  const [swapTable1, setSwapTable1] = useState("");
  const [swapTable2, setSwapTable2] = useState("");
  const [showMoveGuestsModal, setShowMoveGuestsModal] = useState(false);
  const [moveToTable, setMoveToTable] = useState("");
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  const [isMainMenuBurgerOpen, setIsMainMenuBurgerOpen] = useState(false);
  const [showSaveSetModal, setShowSaveSetModal] = useState(false);

  // צבעים לטווחים
  const RANGE_COLORS = [
    "#28a745", // ירוק
    "#007bff", // כחול
    "#ff9800", // כתום
    "#e91e63", // ורוד
    "#9c27b0", // סגול
    "#795548", // חום
    "#00bcd4", // טורקיז
    "#000000", // כתום כהה
    "#8bc34a", // ירוק בהיר
    "#959595", // צהוב
  ];

  // בניית מיפוי טווחים: מפתח ראשי -> כל השולחנות בקבוצה
  const tableRanges = {};
  user.tablesArray.forEach((table, idx) => {
    const title = table.title || "";
    if (title.startsWith("או")) {
      // שולחן ראשי
      const mainTable = (idx + 1).toString();
      const linked = title
        .replace("או", "")
        .replace(/^[ ]+/, "")
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      const group = [mainTable, ...linked];
      // סדר אחיד
      group.sort((a, b) => parseInt(a) - parseInt(b));
      const key = group.join("-");
      tableRanges[key] = group;
    }
  });
  // הוספת שולחנות "מתפרס עם" לקבוצות
  user.tablesArray.forEach((table, idx) => {
    const title = table.title || "";
    if (title.startsWith("מתפרס עם ")) {
      const mainTable = title.replace("מתפרס עם ", "").trim();
      // חפש קבוצה מתאימה
      Object.keys(tableRanges).forEach((key) => {
        if (
          tableRanges[key].includes(mainTable) &&
          !tableRanges[key].includes((idx + 1).toString())
        ) {
          tableRanges[key].push((idx + 1).toString());
          tableRanges[key].sort((a, b) => parseInt(a) - parseInt(b));
        }
      });
    }
  });
  // מיפוי: מספר שולחן -> אינדקס צבע
  const tableToRangeColorIdx = {};
  Object.keys(tableRanges).forEach((key, i) => {
    tableRanges[key].forEach((tableNum) => {
      tableToRangeColorIdx[tableNum] = i % RANGE_COLORS.length;
    });
  });

  useEffect(() => {
    dispatch(checkAuth());
  }, []);

  // טעינת שמירות מערכי העזרים
  useEffect(() => {
    if (isTal) {
      setShowLoading(true);
      dispatch(getAllH()).then((res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        setShowLoading(false);
      });
      return () => {
        dispatch(cleanAll());
      };

      const saved = sessionStorage.getItem("savedHelperSets");
      if (saved) {
        try {
          setSavedHelperSets(JSON.parse(saved));
        } catch (error) {
          console.error("Error loading saved helper sets:", error);
        }
      }
    }
  }, [isTal]);

  // Debounce לחיפוש - 1 שנייה
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     console.log("Debounced search text:", searchText);
  //     setDebouncedSearchText(searchText);
  //   }, 1000); // 1 שנייה
  //   return () => clearTimeout(handler);
  // }, [searchText]);

  // עדכון השולחנות שצריכים להבהב כאשר המשתמש סיים להקליד
  // useEffect(() => {
  //   console.log("Blinking effect triggered with:", debouncedSearchText);
  //   if (what2show === "נותרו") {
  //     const tableNumbers = findTablesForGuest(debouncedSearchText);
  //     console.log("Found table numbers:", tableNumbers);
  //     setBlinkingTables(tableNumbers);
  //     setMarkedTables([]); // ניקוי סימונים קודמים

  //     // הצגת הודעה אם האורח נמצא בשולחן
  //     if (tableNumbers.length > 0 && debouncedSearchText) {
  //       const tableList = tableNumbers.join(", ");
  //       toast.info(`האורח נמצא בשולחנות: ${tableList}`, {
  //         position: "top-center",
  //         autoClose: 3000,
  //       });
  //     } else if (debouncedSearchText && tableNumbers.length === 0) {
  //       // בדיקה אם האורח קיים אבל לא בשולחן
  //       const guestExists = Object.values(guests).some(
  //         (guest) =>
  //           guest.name
  //             ?.toLowerCase()
  //             .includes(debouncedSearchText.toLowerCase()) ||
  //           guest.phone?.includes(debouncedSearchText)
  //       );

  //       if (guestExists) {
  //         toast.info("האורח נמצא ברשימת 'נותרו' - הוא עדיין לא הושבת לשולחן", {
  //           position: "top-center",
  //           autoClose: 3000,
  //         });
  //       }
  //     }

  //     // עצירת ההבהוב אחרי 3 שניות
  //     if (tableNumbers.length > 0) {
  //       const timer = setTimeout(() => {
  //         setBlinkingTables([]);
  //         setMarkedTables(tableNumbers); // שמירת השולחנות כמסומנים
  //       }, 3000);

  //       return () => clearTimeout(timer);
  //     }
  //   } else {
  //     setBlinkingTables([]);
  //     setMarkedTables([]); // הסרת הסימון כשמתחלף למסך אחר
  //   }
  // }, [debouncedSearchText, what2show, guests]);

  const arr2json = (guests, key) => {
    let arr = [];
    for (const [key, value] of Object.entries(guests))
      if (
        (searchText
          .toLowerCase()
          .split(" ")
          .filter((i) => value.name?.toLowerCase().includes(i.toLowerCase()))
          .length === searchText.toLowerCase().split(" ").length ||
          value.phone?.includes(searchText) ||
          searchText === "") &&
        parseInt(value.accept) > 0
      )
        arr.push(value);
    // for (const [key, value] of Object.entries(guests)) arr.push(value);
    let obj = {};
    for (let i = 0; i < arr.length; i++)
      if (obj[arr[i][key]] === undefined)
        obj = { ...obj, [arr[i][key]]: { [arr[i]._id]: arr[i] } };
      else
        obj = {
          ...obj,
          [arr[i][key]]: {
            ...obj[arr[i][key]],
            [arr[i]._id]: arr[i],
          },
        };
    return obj;
  };

  const objGuestsByTable = useMemo(() => arr2json(guests, "table"), [guests]);

  const handleEditTable = async (table, id) => {
    if (
      parseInt(table) !== 0 &&
      user.tablesArray[parseInt(table) - 1].title == "רזרבה"
    )
      toast.warn("שולחן רזרבה - לא ניתן להושיב");
    else {
      if (
        user.tablesArray[parseInt(table) - 1] !== undefined ||
        parseInt(table) == 0
      ) {
        dispatch(editMany({ ids: [id], table: parseInt(table) })).then(
          (res) => {
            if (res.payload?.error) toast.error(res.payload?.error);
            else {
              setFlag((prevState) => !prevState);
              toast.success("הפועלה בוצעה בהצלחה!");
              // setShowEditTable(false);
            }
          }
        );
      } else alert("שולחן לא תקין או לא קיים");
    }
  };

  const handleEditTableMany = async () => {
    if (
      parseInt(table) !== 0 &&
      user.tablesArray[parseInt(table) - 1].title == "רזרבה"
    )
      toast.warn("שולחן רזרבה - לא ניתן להושיב");
    else {
      if (Object.keys(multyChoise).length) {
        if (
          user.tablesArray[parseInt(table) - 1] !== undefined ||
          parseInt(table) == 0
        ) {
          setShowLoading(true);
          dispatch(
            editMany({ ids: Object.keys(multyChoise), table: parseInt(table) })
          ).then((res) => {
            setFlag(!flag);
            setShowLoading(false);
            if (res.payload?.error) toast.error(res.payload?.error);
            else {
              toast.success("הפעולה בוצעה בהצלחה!");
              setMultiSelect(!multiSelect);
              multyChoise = {};
              multyChoiseCounter = 0;
              setSelected(0);
              setTable(null);
            }
          });
        } else alert("שולחן לא תקין או לא קיים");
      } else toast.warning("לא נבחרו אורחים");
    }
  };

  const add_del = (id, amount) => {
    if (multyChoise[id] !== undefined) {
      delete multyChoise[id];
      multyChoiseCounter -= amount;
    } else {
      multyChoise[id] = true;
      multyChoiseCounter += amount;
    }
    setSelected(multyChoiseCounter);
    setClosenessChosenFlag(!closenessChosenFlag);
  };

  const addOrDeleteAllTable = (tableNum) => {
    let obj = arr2json(guests, "table");
    let guestsT = obj[tableNum] !== undefined ? obj[tableNum] : {};
    for (const [key, value] of Object.entries(guestsT))
      add_del(value._id, value.accept);
  };

  // Function to check if all guests in a table are selected
  const areAllGuestsInTableSelected = (tableNum) => {
    let obj = arr2json(guests, "table");
    let guestsT = obj[tableNum] !== undefined ? obj[tableNum] : {};
    const tableGuests = Object.values(guestsT);

    if (tableGuests.length === 0) return false;

    return tableGuests.every((guest) => multyChoise[guest._id] !== undefined);
  };

  let tablesArray = useMemo(() => {
    let tables = [];
    let array = [];
    let temp = [];
    let count = 0;
    let totalCount = 0;
    let totalArrived = 0;
    let tableArrived = 0;
    let obj = { ...arr2json(guests, "table") };
    if (user.tablesArray.length > 0)
      // אם קיימים שולחנות
      for (let i = 0; i < user.tablesArray.length; i++) {
        // עבור כל שולחן
        if (obj[i + 1] === undefined) {
          if (searchText === "")
            // אם לא קיימים אורחים בשולחן זה - הכנסת כותרת
            tables.push(
              <TableCard>
                <TheadTables
                  multy={multiSelect}
                  addOrDeleteAllTable={addOrDeleteAllTable}
                  key={i + 1}
                  table={i + 1}
                  amount={user.tablesArray[i].amount}
                  sit={0}
                  closeness={user.tablesArray[i].title}
                />
              </TableCard>
            );
        } else {
          for (const [key, value] of Object.entries(obj[i + 1])) {
            // סכום כל מי שהגיע בפועל
            // if (parseInt(value.arrived) >= 0) {
            //   count += parseInt(value.arrived);
            // }
            parseInt(value.arrived) >= 0
              ? (count += parseInt(value.arrived))
              : value.accept
              ? (count += parseInt(value.accept))
              : console.log("");
            parseInt(value.arrived) >= 0 &&
              (tableArrived += parseInt(value.arrived));
            temp.push(
              <TrTables
                title={title}
                checked={multyChoise[value._id] !== undefined}
                key={value._id}
                index={value._id}
                handleEditTable={handleEditTable}
                data={value}
                add_del={add_del}
                multy={multiSelect}
              />
            );
          }
          totalCount += parseInt(count);
          if (temp.length > 0) {
            array.push(
              <TheadTables
                multy={multiSelect}
                addOrDeleteAllTable={addOrDeleteAllTable}
                key={i + 1}
                table={i + 1}
                amount={user.tablesArray[i].amount}
                sit={count}
                closeness={user.tablesArray[i].title}
              />
            );
            array.push(...temp);
            tables.push(<TableCard key={i + 1000}>{array}</TableCard>);
          }
          array = [];
          temp = [];
          count = 0;
          tableArrived = 0;
        }
      }

    return [tables, totalArrived];
  }, [
    guests,
    multiSelect,
    selected,
    user.tablesArray,
    searchText,
    what2show,
    isTal,
    title,
  ]);

  let guestsArray = useMemo(() => {
    let counter = [0, 0, 0]; // 0 - seat, 1 - stand, 2 - arrive
    const updateCounter = (amount, table, arrive) => {
      if (table) counter[0] += amount;
      else counter[1] += amount;
      if (arrive != null) {
        counter[2] += parseInt(arrive);
        // console.log(parseInt(arrive));
      }
    };
    const getBackground = (table) => {
      if (table > 0) return "#7b96c4";
      else return "#ecac70";
    };
    let arr = [];
    let sortedArray = [];
    if (Object.keys(guests).length > 0) {
      for (const [key, value] of Object.entries(guests)) {
        updateCounter(value.accept, value.table, value.arrived);
        if (what2show === "נותרו" && parseInt(value.table) > 0) continue;
        else if (what2show === "הושבתי" && !value.table) continue;
        if (
          (searchText
            .toLowerCase()
            .split(" ")
            .filter((i) => value.name?.toLowerCase().includes(i.toLowerCase()))
            .length === searchText.toLowerCase().split(" ").length ||
            value.phone?.includes(searchText) ||
            searchText === "") &&
          parseInt(value.accept) > 0
        )
          sortedArray.push(value);
      }
      let cats = [];
      let tempCloseness = "";
      let categories = [];
      let acceptClosenessCounter = 0;
      if (sortedArray.length) {
        sortedArray.sort(
          (a, b) =>
            a["closeness"].localeCompare(b["closeness"]) ||
            a["name"].localeCompare(b["name"])
        );
        for (let i = 0; i < sortedArray.length; i++) {
          acceptClosenessCounter += sortedArray[i].accept;
          if (sortedArray[i].closeness !== tempCloseness) {
            if (i !== 0 && searchText === "") {
              acceptClosenessCounter -= sortedArray[i].accept;
              cats.push(
                <div style={{ padding: "10px 0", cursor: "pointer" }}>
                  <RespFont
                    onClick={() =>
                      handleClickScroll(sortedArray[i - 1].closeness + "tables")
                    }
                    style={{
                      background: addAlpha("#7b96c4", 0.15),
                      borderRadius: "3px",
                      padding: "5px 8px",
                      width: "max-content",
                      margin: "5px",
                      cursor: "pointer",
                    }}
                  >
                    {sortedArray[i - 1].closeness +
                      " " +
                      acceptClosenessCounter}
                  </RespFont>
                </div>
              );
              acceptClosenessCounter = sortedArray[i].accept;
            }
            categories.push({
              id: sortedArray[i].closeness,
              name: sortedArray[i].closeness,
            });
            arr.push(
              <FlexRowStart
                id={sortedArray[i].closeness + "tables"}
                onClick={() => {
                  if (multiSelect) {
                    let temp = sortedArray.filter(
                      (x) => x.closeness === sortedArray[i].closeness
                    );
                    for (let j = 0; j < temp.length; j++)
                      add_del(temp[j]._id, temp[j].accept);
                  }
                }}
                key={i + "c"}
                style={{
                  marginTop: "15px",
                  cursor: multiSelect ? "pointer" : "auto",
                }}
              >
                <MediumFont
                  csize={"18px"}
                  psize={"16px"}
                  style={{
                    marginRight: "5px",
                    textDecoration: "underline",
                    textDecorationColor: "#7b96c4",
                    textDecorationThickness: "2px",
                  }}
                >
                  {sortedArray[i].closeness}
                </MediumFont>
              </FlexRowStart>
            );
            tempCloseness = sortedArray[i].closeness;
          }
          arr.push(
            <GuestCard
              style={{ width: "92%", margin: "5px auto", padding: "10px 5px" }}
              background={
                multyChoise[sortedArray[i]._id] !== undefined
                  ? "#c1d1eb79"
                  : "#f2f2f2"
              }
              border={getBackground(parseInt(sortedArray[i].table))}
              key={i}
              onClick={() => {
                if (!multiSelect) console.log("");
                else {
                  if (sortedArray[i].table == 0)
                    add_del(sortedArray[i]._id, sortedArray[i].accept);
                  else alert("ניתן לשנות שולחן אך ורק מתוך השולחן");
                }
              }}
            >
              <div>{sortedArray[i].table})</div>
              <div
                style={{
                  width: "max-content",
                  textAlign: "right",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              >
                {sortedArray[i].name}
              </div>
              <FlexRowBetween
                style={{
                  width: "max-content",
                  marginLeft: "0px",
                }}
              >
                {sortedArray[i].notes !== "" && (
                  <img
                    src={notes}
                    alt="notes"
                    style={{ marginLeft: "0px", width: "25px" }}
                  />
                )}
                <div style={{ paddingLeft: "0px" }}>
                  {sortedArray[i].accept}
                </div>
              </FlexRowBetween>
            </GuestCard>
          );
        }
        if (searchText === "")
          cats.push(
            <div style={{ padding: "10px 0", cursor: "pointer" }}>
              <RespFont
                onClick={() =>
                  handleClickScroll(
                    sortedArray[sortedArray.length - 1].closeness + "tables"
                  )
                }
                style={{
                  background: addAlpha("#7b96c4", 0.15),
                  borderRadius: "3px",
                  padding: "5px 8px",
                  width: "max-content",
                  margin: "5px",
                }}
              >
                {sortedArray[sortedArray.length - 1].closeness +
                  " " +
                  acceptClosenessCounter}
              </RespFont>
            </div>
          );
      }
      setCats(cats);
    }
    return [arr, counter];
  }, [
    guests,
    searchText,
    what2show,
    closenessChosenFlag,
    multiSelect,
    selected,
    multyChoise,
    // handleGetAll,
  ]);

  // UseInterval(
  //   async () => {
  //     if (isTal) handleGetAll();
  //   },
  //   isTal ? 90000 : 30000
  // );

  const [deltaPosition, setDeltaPosition] = useState({
    x: 0,
    y: 0,
  });
  const handleDrag = (e, ui) => {
    const { x, y } = deltaPosition;
    setDeltaPosition({
      x: x + ui.deltaX,
      y: y + ui.deltaY,
    });
  };
  const [activeDrags, setSctiveDrags] = useState(0);
  const onStart = () => {
    setSctiveDrags(activeDrags + 1);
  };

  const handleSetShowAddGuest = () => {
    setShowAddGuest(true);
    setShowMenu(false);
  };

  const onStop = () => {
    setSctiveDrags(activeDrags - 1);
  };
  const dragHandlers = {
    onStart: onStart,
    onStop: onStop,
  };
  let widthS = window.innerWidth; // 1728

  const deletePhoto1 = async () => dispatch(deletePhoto(user.sketch));
  const deletePhotoOnly = async () => {
    await deletePhoto1();
    dispatch(editDetails({ sketch: "" })).then((res) => {
      if (!res.payload?.error) toast.success("הפעולה הצליחה!!");
      else toast.error("הפעולה נכשלה, פנה לתמיכה");
    });
  };

  const handleOpenArrange = () => {
    setTablesPositions(
      user.tablesArray.map((table) => ({
        x: table.x ?? 20,
        y: table.y ?? 80,
        width: table.width ?? 60,
        height: table.height ?? 60,
        shape: table.shape ?? "square", // Default to square
        rotation: table.rotation ?? 0, // Default rotation is 0 degrees
      }))
    );
    // Load saved zoom level
    setZoomLevel(user.tables?.zoomLevel || 0.7);
    setShowTableArrange(true);
  };

  let extra = [];
  if (isTal) {
    // extra.push(
    //   <TextWithPic key={4} onClick={() => setReception(!reception)}>
    //     {reception ? "מעבר למי כאן?" : "מעבר לקבלת פנים"}
    //   </TextWithPic>
    // );
    extra.push(
      <TextWithPic key={5} onClick={handleSetShowAddGuest}>
        הוספת אורח להושבה
      </TextWithPic>
    );
    // extra.push(
    //   <TextWithPic
    //     key={5}
    //     onClick={() => handleGetAll()}
    //     style={{ width: "max-content" }}
    //   >
    //     {`סומנו עד כה ${
    //       parseInt(guestsArray[1][2]) - 1
    //     } אורחים\nלרענון יש ללחוץ כאן`}
    //   </TextWithPic>
    // );
  }
  // extra = [
  //   <TextWithPic key={4} onClick={() => setReception(!reception)}>
  //     {reception ? "מי כאן?" : "קבלת פנים"}
  //   </TextWithPic>,
  //   <TextWithPic
  //     key={5}
  //     onClick={() => handleGetAll()}
  //     style={{ width: "max-content" }}
  //   >
  //     {`סומנו עד כה ${
  //       parseInt(guestsArray[1][2]) - 1
  //     } אורחים\nלרענון יש ללחוץ כאן`}
  //   </TextWithPic>,
  // ];
  if (user.sketch == "")
    extra.push(
      <TextWithPic key={10} onClick={() => setEditSketch(true)}>
        העלאת סקיצה
      </TextWithPic>
    );
  else {
    extra.push(
      <TextWithPic key={11} onClick={deletePhotoOnly}>
        מחיקת סקיצה
      </TextWithPic>
    );
  }

  const handleTableMouseDown = (e, idx) => {
    if (e.target.className === "resize-handle") return;

    // אם מצב הצגת אורחים פעיל או השולחנות נעולים - לא לאפשר גרירה
    if (tablesLocked) {
      return;
    }

    // אחרת - אפשר גרירה
    setDraggedTable(idx);
    setDragOffset({
      x: e.clientX - tablesPositions[idx].x * zoomLevel,
      y: e.clientY - tablesPositions[idx].y * zoomLevel,
    });
  };

  const handleResizeMouseDown = (e, idx) => {
    e.stopPropagation();
    if (tablesLocked) return; // לא לאפשר שינוי גודל אם נעול או במצב הצגת אורחים
    setResizeTable(idx);
    setResizeStart({
      x: e.clientX,
      y: e.clientY,
      width: tablesPositions[idx].width,
      height: tablesPositions[idx].height,
    });
  };

  const handleRotateMouseDown = (e, idx) => {
    e.stopPropagation();
    if (tablesLocked) return; // לא לאפשר סיבוב אם נעול
    setRotateTable(idx);

    // Calculate center based on table position and size
    const table = tablesPositions[idx];
    const centerX = (table.x + table.width / 2) * zoomLevel;
    const centerY = (table.y + table.height / 2) * zoomLevel;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
    setRotateStart({
      x: e.clientX,
      y: e.clientY,
      angle: startAngle,
    });
  };

  const handleMouseMove = (e) => {
    if (draggedTable !== null) {
      const newX = (e.clientX - dragOffset.x) / zoomLevel;
      const newY = (e.clientY - dragOffset.y) / zoomLevel;

      // Snap to grid for better alignment
      const snappedX = Math.round(newX / GRID_SIZE) * GRID_SIZE;
      const snappedY = Math.round(newY / GRID_SIZE) * GRID_SIZE;

      setTablesPositions((prev) => {
        const newPositions = [...prev];
        newPositions[draggedTable] = {
          ...newPositions[draggedTable],
          x: Math.max(0, snappedX),
          y: Math.max(0, snappedY),
        };
        return newPositions;
      });
    } else if (draggedHelper !== null) {
      const newX = (e.clientX - dragOffset.x) / zoomLevel;
      const newY = (e.clientY - dragOffset.y) / zoomLevel;

      // Snap to grid for better alignment
      const snappedX = Math.round(newX / GRID_SIZE) * GRID_SIZE;
      const snappedY = Math.round(newY / GRID_SIZE) * GRID_SIZE;

      setHelperElements((prev) => ({
        ...prev,
        [draggedHelper]: {
          ...prev[draggedHelper],
          x: Math.max(0, snappedX),
          y: Math.max(0, snappedY),
        },
      }));
    } else if (resizeTable !== null) {
      // Resize mode
      const deltaX = (e.clientX - resizeStart.x) / zoomLevel;
      const deltaY = (e.clientY - resizeStart.y) / zoomLevel;
      const newWidth = Math.max(50, resizeStart.width + deltaX);
      const newHeight = Math.max(50, resizeStart.height + deltaY);

      // Snap resize to grid
      const snappedWidth = Math.round(newWidth / GRID_SIZE) * GRID_SIZE;
      const snappedHeight = Math.round(newHeight / GRID_SIZE) * GRID_SIZE;

      setTablesPositions((prev) => {
        const newPositions = [...prev];
        newPositions[resizeTable] = {
          ...newPositions[resizeTable],
          width: Math.max(GRID_SIZE, snappedWidth),
          height: Math.max(GRID_SIZE, snappedHeight),
        };
        return newPositions;
      });
    } else if (resizeHelper !== null) {
      // Helper resize mode
      const deltaX = (e.clientX - resizeStart.x) / zoomLevel;
      const deltaY = (e.clientY - resizeStart.y) / zoomLevel;
      const newWidth = Math.max(60, resizeStart.width + deltaX);
      const newHeight = Math.max(30, resizeStart.height + deltaY);

      // Snap resize to grid
      const snappedWidth = Math.round(newWidth / GRID_SIZE) * GRID_SIZE;
      const snappedHeight = Math.round(newHeight / GRID_SIZE) * GRID_SIZE;

      setHelperElements((prev) => ({
        ...prev,
        [resizeHelper]: {
          ...prev[resizeHelper],
          width: Math.max(GRID_SIZE, snappedWidth),
          height: Math.max(GRID_SIZE, snappedHeight),
        },
      }));
    } else if (rotateTable !== null) {
      // Table rotation mode
      const table = tablesPositions[rotateTable];
      const centerX = (table.x + table.width / 2) * zoomLevel;
      const centerY = (table.y + table.height / 2) * zoomLevel;
      const currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      const deltaAngle = currentAngle - rotateStart.angle;

      // Add sensitivity control - only rotate if movement is significant
      const minRotationThreshold = 0.02; // Minimum radians to trigger rotation
      if (Math.abs(deltaAngle) > minRotationThreshold) {
        const rotationAmount = deltaAngle * (180 / Math.PI);
        const newRotation =
          (tablesPositions[rotateTable].rotation + rotationAmount) % 360;

        setTablesPositions((prev) => {
          const newPositions = [...prev];
          newPositions[rotateTable] = {
            ...newPositions[rotateTable],
            rotation: newRotation,
          };
          return newPositions;
        });

        // Update the start angle to prevent accumulation
        setRotateStart((prev) => ({
          ...prev,
          angle: currentAngle,
        }));
      }
    } else if (rotateHelper !== null) {
      // Helper rotation mode
      const helper = helperElements[rotateHelper];
      const centerX = (helper.x + helper.width / 2) * zoomLevel;
      const centerY = (helper.y + helper.height / 2) * zoomLevel;
      const currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      const deltaAngle = currentAngle - rotateStart.angle;

      // Add sensitivity control - only rotate if movement is significant
      const minRotationThreshold = 0.02; // Minimum radians to trigger rotation
      if (Math.abs(deltaAngle) > minRotationThreshold) {
        const rotationAmount = deltaAngle * (180 / Math.PI);
        const newRotation =
          (helperElements[rotateHelper].rotation + rotationAmount) % 360;

        setHelperElements((prev) => ({
          ...prev,
          [rotateHelper]: {
            ...prev[rotateHelper],
            rotation: newRotation,
          },
        }));

        // Update the start angle to prevent accumulation
        setRotateStart((prev) => ({
          ...prev,
          angle: currentAngle,
        }));
      }
    }
  };

  const handleMouseUp = () => {
    if (draggedTable !== null) {
      setDraggedTable(null);
      setDragOffset({ x: 0, y: 0 });
    }
    if (draggedHelper !== null) {
      setDraggedHelper(null);
      setDragOffset({ x: 0, y: 0 });
    }
    if (resizeTable !== null) {
      setResizeTable(null);
      setResizeStart({ x: 0, y: 0, width: 0, height: 0 });
    }
    if (resizeHelper !== null) {
      setResizeHelper(null);
      setResizeStart({ x: 0, y: 0, width: 0, height: 0 });
    }
    if (rotateTable !== null) {
      setRotateTable(null);
      setRotateStart({ x: 0, y: 0, angle: 0 });
    }
    if (rotateHelper !== null) {
      setRotateHelper(null);
      setRotateStart({ x: 0, y: 0, angle: 0 });
    }
  };

  useEffect(() => {
    if (showTableArrange) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [
    showTableArrange,
    draggedTable,
    dragOffset,
    tablesPositions,
    resizeTable,
    resizeStart,
    rotateTable,
    rotateStart,
    draggedHelper,
    resizeHelper,
    rotateHelper,
    helperElements,
    zoomLevel,
  ]);

  const handleSaveTablePositions = () => {
    let newArray = [];
    for (let i = 0; i < user.tablesArray.length; i++) {
      newArray.push({
        amount: user.tablesArray[i].amount,
        chairs: user.tablesArray[i].chairs,
        default: user.tablesArray[i].default,
        title: user.tablesArray[i].title,
        x: tablesPositions[i].x,
        y: tablesPositions[i].y,
        width: tablesPositions[i].width,
        height: tablesPositions[i].height,
        shape: tablesPositions[i].shape || "square", // Save the shape
        rotation: tablesPositions[i].rotation || 0, // Save the rotation
      });
    }
    setShowLoading(true);
    dispatch(
      editDetails({
        tablesArray: [...newArray],
        tables: {
          ...user.tables,
          helpers: helperElements,
          zoomLevel: zoomLevel,
        },
      })
    ).then((res) => {
      setShowLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        handleCloseTableArrange();
      } else toast.error(res.payload?.error);
    });
  };

  // קומפוננטת ניהול טווחים
  function RangeManager({ user, hand }) {
    const [showAddForm, setShowAddForm] = React.useState(false);
    const [editRange, setEditRange] = React.useState(null); // {numbers, name, mainTable}
    return (
      <div
        style={{
          width: 420,
          background: "#fff",
          borderRadius: 10,
          padding: 24,
          minHeight: 180,
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
          ניהול טווחים
        </div>
        {!showAddForm && !editRange && (
          <button
            style={{
              background: "#28a745",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginBottom: 12,
            }}
            onClick={() => setShowAddForm(true)}
          >
            הוספת טווח
          </button>
        )}
        {showAddForm && (
          <AddRangeForm
            user={user}
            hand={hand}
            onCancel={() => setShowAddForm(false)}
          />
        )}
        {editRange && (
          <AddRangeForm
            user={user}
            hand={hand}
            onCancel={() => setEditRange(null)}
            initialNumbers={editRange.numbers}
            initialName={editRange.name}
            mainTable={editRange.mainTable}
            isEdit
          />
        )}
        {/* רשימת הטווחים */}
        <div style={{ marginTop: 24, textAlign: "right" }}>
          {user.tablesArray
            .map((table, idx) => ({
              idx,
              title: table.title || "",
            }))
            .filter(({ title }) => title.startsWith("או"))
            .map(({ idx, title }, i) => {
              // חילוץ מספרי השולחנות והשם
              const match = title.match(/^או\s*([\d, ]+)(.*)$/);
              let numbers = [];
              let name = "";
              if (match) {
                numbers = match[1]
                  .split(",")
                  .map((n) => n.trim())
                  .filter(Boolean)
                  .map(Number);
                numbers.unshift(idx + 1); // הוספת השולחן הראשי
                numbers = [...new Set(numbers)].sort((a, b) => a - b);
                name = match[2]?.trim() || "";
              }
              // צבע לפי אינדקס
              const color = RANGE_COLORS[i % RANGE_COLORS.length];
              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 12,
                    background: "#f8f9fa",
                    borderRadius: 8,
                    padding: "8px 12px",
                  }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: color,
                      border: "2px solid #fff",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                    }}
                    title={name || "ללא שם"}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 16 }}>
                      טווח: {numbers.join(", ")}
                    </div>
                    {name && (
                      <div style={{ fontSize: 14, color: "#555" }}>{name}</div>
                    )}
                  </div>
                  <button
                    style={{
                      background: "#ffc107",
                      color: "#222",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() =>
                      setEditRange({
                        numbers,
                        name,
                        mainTable: Math.min(...numbers),
                      })
                    }
                  >
                    עריכה
                  </button>
                  <button
                    style={{
                      background: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "4px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => handleDeleteRange(numbers)}
                  >
                    מחיקה
                  </button>
                </div>
              );
            })}
          {user.tablesArray.filter((table) =>
            (table.title || "").startsWith("או")
          ).length === 0 && (
            <div style={{ color: "#888", fontSize: 16, marginTop: 24 }}>
              לא קיימים טווחים
            </div>
          )}
        </div>
      </div>
    );
  }

  const handleTableRightClick = (idx, e) => {
    e.preventDefault();
    const tableNum = idx + 1;
    const isReserveTable = user.tablesArray[idx].title === "רזרבה";

    // אם זה שולחן רזרבה, פשוט הצג את האורחים
    if (isReserveTable) {
      let guestsForTable = objGuestsByTable[tableNum] || {};
      let guests = [];
      for (const [key, value] of Object.entries(guestsForTable)) {
        guests.push({
          name: value.name,
          accept: parseInt(value.accept),
          arrived:
            parseInt(value.arrived) >= 0 ? parseInt(value.arrived) : null,
        });
      }

      setTableGuestsData({
        title: "",
        guests: guests,
        tableNumber: tableNum,
      });
      setShowTableGuests(true);
      return;
    }

    // אם זה לא שולחן רזרבה, הצג תפריט עם אפשרויות
    setCurrentTableForSelection(tableNum);
    setShowTableContextMenu(true);
  };

  const handleHelperMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר גרירה אם נעול
    if (e.target.className === "helper-resize-handle") return;
    setDraggedHelper(helperType);
    setDragOffset({
      x: e.clientX - helperElements[helperType].x * zoomLevel,
      y: e.clientY - helperElements[helperType].y * zoomLevel,
    });
  };

  const handleHelperResizeMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר שינוי גודל אם נעול
    e.stopPropagation();
    setResizeHelper(helperType);
    setResizeStart({
      x: e.clientX,
      y: e.clientY,
      width: helperElements[helperType].width,
      height: helperElements[helperType].height,
    });
  };

  const handleHelperRotateMouseDown = (helperType, e) => {
    if (tablesLocked) return; // לא לאפשר סיבוב אם נעול
    e.stopPropagation();
    setRotateHelper(helperType);

    // Calculate center based on helper position and size
    const helper = helperElements[helperType];
    const centerX = (helper.x + helper.width / 2) * zoomLevel;
    const centerY = (helper.y + helper.height / 2) * zoomLevel;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
    setRotateStart({
      x: e.clientX,
      y: e.clientY,
      angle: startAngle,
    });
  };

  const handleHelperRightClick = (helperType, e) => {
    e.preventDefault();
    setEditingHelper(helperType);
    setNewHelperTitle(helperElements[helperType].title);
    setNewHelperColor(helperElements[helperType].color);
    setNewHelperBgColor(helperElements[helperType].backgroundColor);
    setNewHelperTextAlign(helperElements[helperType].textAlign || "center");
    setNewHelperFontSize(helperElements[helperType].fontSize || 18);
    setShowHelperModal(true);
  };

  const handleBringToFront = (helperType) => {
    const newHelperElements = { ...helperElements };
    const helperToMove = newHelperElements[helperType];

    // Remove the helper from its current position
    delete newHelperElements[helperType];

    // Add it back at the end (highest z-index)
    newHelperElements[helperType] = helperToMove;

    setHelperElements(newHelperElements);

    // Save helpers immediately
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: newHelperElements,
        },
      })
    );

    toast.success("העזר הועבר לקידמה");
  };

  // פונקציה לחישוב צבע רקע אוטומטי - גרסה חלשה/עדינה יותר
  const getBackgroundColorWithOpacity = (color) => {
    // המרת hex ל-rgb
    const hex = color.replace("#", "");
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // יצירת גרסה חלשה/עדינה יותר על ידי הוספת לבן (הגדלת הערכים)
    const lightR = Math.min(255, r + Math.round((255 - r) * 0.9));
    const lightG = Math.min(255, g + Math.round((255 - g) * 0.9));
    const lightB = Math.min(255, b + Math.round((255 - b) * 0.9));

    // החזרת צבע חלש/עדין יותר
    return `rgb(${lightR}, ${lightG}, ${lightB})`;
  };

  const handleSaveHelper = () => {
    if (editingHelper) {
      const newHelperElements = {
        ...helperElements,
        [editingHelper]: {
          ...helperElements[editingHelper],
          title: newHelperTitle,
          color: newHelperColor,
          backgroundColor: getBackgroundColorWithOpacity(newHelperColor),
          textAlign: newHelperTextAlign,
          fontSize: newHelperFontSize,
          rotation: helperElements[editingHelper].rotation || 0, // Preserve rotation
        },
      };

      setHelperElements(newHelperElements);

      // Save helpers immediately
      dispatch(
        editDetails({
          tables: {
            ...user.tables,
            helpers: newHelperElements,
          },
        })
      );
    }
    setShowHelperModal(false);
    setEditingHelper(null);
  };

  const handleAddNewHelper = () => {
    const helperId = `helper_${Date.now()}`;
    const newHelperElements = {
      ...helperElements,
      [helperId]: {
        x: 100,
        y: 100,
        width: 80,
        height: 40,
        title: newHelperTitle || "עזר חדש",
        color: newHelperColor,
        backgroundColor: getBackgroundColorWithOpacity(newHelperColor),
        textAlign: newHelperTextAlign,
        fontSize: newHelperFontSize,
        rotation: 0, // Default rotation
      },
    };

    setHelperElements(newHelperElements);

    // Save helpers immediately
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: newHelperElements,
        },
      })
    );

    setNewHelperTitle("");
    setNewHelperColor("#4c6daf");
    setNewHelperBgColor(getBackgroundColorWithOpacity("#4c6daf"));
    setNewHelperTextAlign("center");
    setNewHelperFontSize(18);
    setShowHelperModal(false);
  };

  const handleDeleteHelper = () => {
    if (editingHelper) {
      const newHelperElements = { ...helperElements };
      delete newHelperElements[editingHelper];

      setHelperElements(newHelperElements);

      // Save helpers immediately
      dispatch(
        editDetails({
          tables: {
            ...user.tables,
            helpers: newHelperElements,
          },
        })
      );
    }
    setShowHelperModal(false);
    setEditingHelper(null);
  };

  const handleSaveHelperPositions = () => {
    setShowLoading(true);
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: helperElements,
          zoomLevel: zoomLevel,
        },
      })
    ).then((res) => {
      setShowLoading(false);
      if (!res.payload?.error) {
        toast.success("העזרים נשמרו בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleZoomIn = () => {
    const newZoomLevel = Math.min(zoomLevel + 0.1, 2); // Max zoom 200%
    setZoomLevel(newZoomLevel);

    // Save zoom level to user.tables
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          zoomLevel: newZoomLevel,
        },
      })
    );
  };

  const handleZoomOut = () => {
    const newZoomLevel = Math.max(zoomLevel - 0.1, 0.5); // Min zoom 50%
    setZoomLevel(newZoomLevel);

    // Save zoom level to user.tables
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          zoomLevel: newZoomLevel,
        },
      })
    );
  };

  const handleCloseTableArrange = () => {
    // Save zoom level and helpers before closing
    dispatch(
      editDetails({
        tables: {
          ...user.tables,
          helpers: helperElements,
          zoomLevel: zoomLevel,
        },
      })
    );
    setShowTableArrange(false);
  };

  const tryDetectTableNumbers = (canvas, tables, width, height) => {
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    // Try to detect numbers near each table
    const tablesWithNumbers = tables.map((table, index) => {
      const scaleX = width / 800;
      const scaleY = height / 600;

      // Convert table position back to image coordinates
      const imgX = table.x / scaleX;
      const imgY = table.y / scaleY;

      // Look for numbers in the area around the table
      const detectedNumber = detectNumberNearTable(
        data,
        width,
        height,
        imgX,
        imgY
      );

      return {
        ...table,
        detectedNumber: detectedNumber,
        originalIndex: index,
      };
    });

    // If we detected some numbers, use them for ordering
    const tablesWithDetectedNumbers = tablesWithNumbers.filter(
      (t) => t.detectedNumber !== null
    );

    if (tablesWithDetectedNumbers.length > 0) {
      // Sort by detected numbers
      tablesWithDetectedNumbers.sort(
        (a, b) => a.detectedNumber - b.detectedNumber
      );

      // Create a mapping from detected number to table index
      const numberToIndexMap = {};
      tablesWithDetectedNumbers.forEach((table, sortedIndex) => {
        numberToIndexMap[table.detectedNumber] = table.originalIndex;
      });

      // Reorder tables based on detected numbers
      const reorderedTables = [];
      for (let i = 0; i < tables.length; i++) {
        const tableNumber = i + 1; // Table numbers start from 1
        const originalIndex = numberToIndexMap[tableNumber];

        if (originalIndex !== undefined) {
          reorderedTables[i] = tables[originalIndex];
        } else {
          // If we couldn't detect this table number, keep original position
          reorderedTables[i] = tables[i];
        }
      }

      return reorderedTables;
    }

    // If no numbers detected, return original order
    return tables;
  };

  const detectNumberNearTable = (data, width, height, centerX, centerY) => {
    // Look for high contrast areas (potential numbers) near the table
    const searchRadius = 60;
    const numberCandidates = [];

    for (let y = centerY - searchRadius; y < centerY + searchRadius; y += 1) {
      for (let x = centerX - searchRadius; x < centerX + searchRadius; x += 1) {
        if (x < 0 || x >= width || y < 0 || y >= height) continue;

        const index = (y * width + x) * 4;
        const r = data[index];
        const g = data[index + 1];
        const b = data[index + 2];

        // Look for high contrast (potential text)
        const brightness = (r + g + b) / 3;
        if (brightness < 30 || brightness > 220) {
          // Very dark or very light
          numberCandidates.push({ x, y, brightness });
        }
      }
    }

    // If we found enough high-contrast pixels, try to extract the number
    if (numberCandidates.length > 30) {
      return extractNumberFromCandidates(
        numberCandidates,
        centerX,
        centerY,
        width,
        height
      );
    }

    return null;
  };

  const extractNumberFromCandidates = (
    candidates,
    centerX,
    centerY,
    width,
    height
  ) => {
    // Group candidates by proximity to find text clusters
    const clusters = [];
    const visited = new Set();

    candidates.forEach((candidate) => {
      if (visited.has(`${candidate.x},${candidate.y}`)) return;

      const cluster = [];
      const queue = [candidate];

      while (queue.length > 0) {
        const current = queue.shift();
        const key = `${current.x},${current.y}`;

        if (visited.has(key)) continue;
        visited.add(key);
        cluster.push(current);

        // Add nearby candidates to queue
        candidates.forEach((other) => {
          const otherKey = `${other.x},${other.y}`;
          if (!visited.has(otherKey)) {
            const distance = Math.sqrt(
              Math.pow(current.x - other.x, 2) +
                Math.pow(current.y - other.y, 2)
            );
            if (distance < 10) {
              // Close enough to be part of same text
              queue.push(other);
            }
          }
        });
      }

      if (cluster.length > 5) {
        // Minimum size for a number
        clusters.push(cluster);
      }
    });

    // Try to identify numbers from clusters
    for (const cluster of clusters) {
      const number = identifyNumberFromCluster(
        cluster,
        centerX,
        centerY,
        width,
        height
      );
      if (number !== null) {
        return number;
      }
    }

    return null;
  };

  const identifyNumberFromCluster = (
    cluster,
    centerX,
    centerY,
    width,
    height
  ) => {
    // Calculate cluster properties
    const minX = Math.min(...cluster.map((c) => c.x));
    const maxX = Math.max(...cluster.map((c) => c.x));
    const minY = Math.min(...cluster.map((c) => c.y));
    const maxY = Math.max(...cluster.map((c) => c.y));

    const clusterWidth = maxX - minX;
    const clusterHeight = maxY - minY;
    const clusterCenterX = (minX + maxX) / 2;
    const clusterCenterY = (minY + maxY) / 2;

    // Check if cluster is near the table center
    const distanceFromTable = Math.sqrt(
      Math.pow(clusterCenterX - centerX, 2) +
        Math.pow(clusterCenterY - centerY, 2)
    );

    if (distanceFromTable > 80) return null; // Too far from table

    // Simple pattern recognition for numbers 1-9
    // This is a basic implementation - could be improved with more sophisticated OCR
    const pattern = analyzeNumberPattern(cluster, clusterWidth, clusterHeight);

    if (pattern !== null) {
      return pattern;
    }

    // Fallback: estimate based on position relative to other tables
    return estimateNumberFromRelativePosition(
      clusterCenterX,
      clusterCenterY,
      width,
      height
    );
  };

  const analyzeNumberPattern = (cluster, width, height) => {
    // Very basic pattern recognition for single digits
    // This is a simplified approach - real OCR would be much more sophisticated

    const density = cluster.length / (width * height);

    // Simple heuristics for common number patterns
    if (density > 0.3 && width < 20 && height < 20) {
      // Could be a number - try to estimate based on shape
      return estimateNumberFromShape(cluster, width, height);
    }

    return null;
  };

  const estimateNumberFromShape = (cluster, width, height) => {
    // Very basic shape analysis
    // This is a placeholder - real implementation would use more sophisticated pattern matching

    // For now, return null to use position-based estimation
    return null;
  };

  const estimateNumberFromRelativePosition = (x, y, width, height) => {
    // Estimate number based on position in the image
    // This assumes a grid layout but doesn't assume chronological numbering

    const gridCols = 4; // Assume max 4 columns
    const gridRows = 3; // Assume max 3 rows

    const col = Math.floor((x / width) * gridCols);
    const row = Math.floor((y / height) * gridRows);

    // Return position in grid (1-based)
    return row * gridCols + col + 1;
  };

  // Note: Complex number detection functions removed - focusing on accurate table positioning instead
  const analyzeSketchImage = (canvas, width, height) => {
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    // Detect dark areas (tables) by looking for clusters of dark pixels
    const visited = new Set();
    const tableClusters = [];

    // Scan for dark pixels (potential tables)
    for (let y = 0; y < height; y += 5) {
      // Sample every 5 pixels for performance
      for (let x = 0; x < width; x += 5) {
        const idx = (y * width + x) * 4;
        const r = data[idx];
        const g = data[idx + 1];
        const b = data[idx + 2];

        // Check if pixel is dark (potential table)
        const brightness = (r + g + b) / 3;
        if (brightness < 100 && !visited.has(`${x},${y}`)) {
          // Found a dark pixel, explore the cluster
          const cluster = exploreCluster(data, width, height, x, y, visited);
          if (cluster.points.length > 50) {
            // Minimum cluster size
            tableClusters.push(cluster);
          }
        }
      }
    }

    // Convert clusters to table positions
    const tables = tableClusters.map((cluster, index) => {
      const centerX = cluster.centerX;
      const centerY = cluster.centerY;

      // Scale to our coordinate system (0-800 x 0-600)
      const scaledX = (centerX / width) * 800;
      const scaledY = (centerY / height) * 600;

      return {
        id: `table-${index + 1}`,
        x: Math.max(0, Math.min(750, scaledX - 25)), // Center the table
        y: Math.max(0, Math.min(550, scaledY - 25)),
        width: 50,
        height: 50,
        shape: "square", // Default shape for scanned tables
        number: index + 1, // Simple sequential numbering
        isReserve: false,
      };
    });

    // Create helpers based on event size
    const helpers = {};
    if (tables.length > 0) {
      helpers.entrance = {
        id: "entrance",
        x: 50,
        y: 50,
        width: 80,
        height: 40,
        title: "כניסה",
        color: "#4CAF50",
        titleAlign: "center",
        fontSize: 14,
      };

      helpers.courtyard = {
        id: "courtyard",
        x: 650,
        y: 50,
        width: 100,
        height: 60,
        title: "רחבה",
        color: "#FF9800",
        titleAlign: "center",
        fontSize: 14,
      };

      helpers.bar = {
        id: "bar",
        x: 50,
        y: 500,
        width: 120,
        height: 50,
        title: "בר",
        color: "#2196F3",
        titleAlign: "center",
        fontSize: 14,
      };
    }

    return { tables, helpers };
  };

  const exploreCluster = (data, width, height, startX, startY, visited) => {
    const queue = [{ x: startX, y: startY }];
    const points = [];
    let minX = startX,
      maxX = startX,
      minY = startY,
      maxY = startY;

    while (queue.length > 0) {
      const { x, y } = queue.shift();
      const key = `${x},${y}`;

      if (visited.has(key) || x < 0 || x >= width || y < 0 || y >= height) {
        continue;
      }

      visited.add(key);

      const idx = (y * width + x) * 4;
      const r = data[idx];
      const g = data[idx + 1];
      const b = data[idx + 2];
      const brightness = (r + g + b) / 3;

      if (brightness < 100) {
        points.push({ x, y });
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);

        // Add neighbors to queue
        queue.push({ x: x + 5, y });
        queue.push({ x: x - 5, y });
        queue.push({ x, y: y + 5 });
        queue.push({ x, y: y - 5 });
      }
    }

    return {
      points,
      centerX: (minX + maxX) / 2,
      centerY: (minY + maxY) / 2,
    };
  };

  const createDefaultLayout = () => {
    const tables = [];
    const helpers = {};

    // Create a more intelligent layout based on table types and amounts
    const numTables = user.tablesArray.length;

    // Group tables by type for better organization
    const regularTables = [];
    const reserveTables = [];

    user.tablesArray.forEach((table, index) => {
      if (table.title === "רזרבה") {
        reserveTables.push({ ...table, originalIndex: index });
      } else {
        regularTables.push({ ...table, originalIndex: index });
      }
    });

    // Layout regular tables in a grid
    const regularCount = regularTables.length;
    const cols = Math.ceil(Math.sqrt(regularCount));
    const rows = Math.ceil(regularCount / cols);

    regularTables.forEach((table, i) => {
      const row = Math.floor(i / cols);
      const col = i % cols;

      tables[table.originalIndex] = {
        x: 150 + col * 140,
        y: 150 + row * 140,
        width: 70,
        height: 70,
        shape: "square", // Default shape for regular tables
      };
    });

    // Layout reserve tables separately (usually in corners or sides)
    reserveTables.forEach((table, i) => {
      const reserveIndex = table.originalIndex;
      tables[reserveIndex] = {
        x: 50 + i * 100,
        y: 50,
        width: 60,
        height: 60,
        shape: "square", // Default shape for reserve tables
      };
    });

    // Add strategic helpers based on layout
    helpers.entrance = {
      x: 50,
      y: 50,
      width: 80,
      height: 40,
      title: "כניסה",
      color: "#4c6daf",
      backgroundColor: "#e0e8f6",
      textAlign: "center",
      fontSize: 12,
    };

    helpers.courtyard = {
      x: 200,
      y: 50,
      width: 100,
      height: 50,
      title: "רחבה",
      color: "#28a745",
      backgroundColor: "#d4edda",
      textAlign: "center",
      fontSize: 12,
    };

    // Add bar only if there are many tables
    if (numTables > 8) {
      helpers.bar = {
        x: 400,
        y: 100,
        width: 80,
        height: 40,
        title: "בר",
        color: "#dc3545",
        backgroundColor: "#f8d7da",
        textAlign: "center",
        fontSize: 12,
      };
    }

    // Add dance floor for large events
    if (numTables > 12) {
      helpers.danceFloor = {
        x: 300,
        y: 400,
        width: 120,
        height: 80,
        title: "רחבת ריקודים",
        color: "#6f42c1",
        backgroundColor: "#e2d9f3",
        textAlign: "center",
        fontSize: 12,
      };
    }

    return { tables, helpers };
  };

  const hand = () => {
    dispatch(checkAuth());
    dispatch(getAll());
  };

  // פונקציה שתמצא איזה שולחן מכיל את האורח שנחפש
  const findTablesForGuest = (searchText) => {
    if (!searchText) return [];

    const matchingTables = new Set();

    for (const [key, guest] of Object.entries(guests)) {
      const matchesSearch =
        guest.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        guest.phone?.includes(searchText);

      if (matchesSearch && guest.table > 0) {
        matchingTables.add(guest.table);
      }
    }

    return Array.from(matchingTables);
  };

  UseInterval(async () => {
    if (isTal) {
      hand();
    }
  }, 90000);

  // פונקציה לשמירת מערך עזרים נוכחי
  const saveCurrentHelperSet = () => {
    const setName =
      customSetName.trim() ||
      `מערך עזרים ${new Date().toLocaleString("he-IL")}`;
    const newSet = {
      name: setName,
      helpers: helperElements,
      createdAt: new Date().toISOString(),
    };
    dispatch(add(newSet)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
    setCustomSetName("");
    setShowNameInput(false);
  };

  // פונקציה לטעינת מערך עזרים
  const loadHelperSet = (set) => {
    setHelperElements(set.helpers);
    setShowSavedSetsModal(false);
    toast.success(`מערך "${set.name}" נטען בהצלחה!`);
  };

  function handleDeleteRange(numbers) {
    if (!window.confirm("האם למחוק את הטווח?")) return;
    const updatedTables = user.tablesArray.map((t, idx) => {
      const tableNum = idx + 1;
      if (numbers.includes(tableNum)) {
        return { ...t, title: "כללי" };
      }
      return t;
    });
    dispatch(
      editDetails({
        tablesArray: updatedTables,
        tables: user.tables,
      })
    ).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        hand();
      } else toast.error(res.payload?.error);
    });
  }

  // פונקציה למחיקת מערך עזרים
  const deleteHelperSet = (setId) => {
    dispatch(deleteF(setId)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  // פונקציה לפתיחת מודל בחירת שולחנות
  const openTableSelectionModal = (tableNum) => {
    if (!tableNum) {
      toast.error("לא נבחר שולחן");
      return;
    }
    setCurrentTableForSelection(tableNum);
    // טעינת השולחנות שכבר נבחרו עבור שולחן זה
    const existingTables = user.tablesArray[tableNum - 1]?.title || "";
    if (existingTables.includes(",")) {
      const tableNumbers = existingTables
        .split(",")
        .map((t) => t.trim())
        .filter((t) => t !== "");
      setSelectedTables(tableNumbers);
    } else {
      setSelectedTables([tableNum.toString()]);
    }
    setShowTableSelectionModal(true);
  };

  // פונקציה לשמירת בחירת השולחנות
  const saveTableSelection = async () => {
    if (!currentTableForSelection) {
      toast.error("לא נבחר שולחן עיקרי");
      return;
    }
    if (selectedTables.length === 0) {
      toast.warn("יש לבחור לפחות שולחן אחד");
      return;
    }

    try {
      const updatedTables = [...user.tablesArray];

      // איפוס כל השולחנות - כל שולחן חוזר למספר בלבד
      updatedTables.forEach((table, index) => {
        updatedTables[index] = {
          ...table,
          title: (index + 1).toString(),
        };
      });

      // יצירת כותרת חדשה עם "או" עבור השולחן הנוכחי
      const otherTables = selectedTables.filter(
        (t) => t !== currentTableForSelection.toString()
      );
      const newTitle =
        otherTables.length > 0
          ? `או ${otherTables.join(", ")}`
          : currentTableForSelection.toString();

      // עדכון השולחן הנוכחי
      updatedTables[currentTableForSelection - 1] = {
        ...updatedTables[currentTableForSelection - 1],
        title: newTitle,
      };

      // עדכון השולחנות האחרים עם "מתפרס עם"
      otherTables.forEach((tableNum) => {
        const tableIndex = parseInt(tableNum) - 1;
        updatedTables[tableIndex] = {
          ...updatedTables[tableIndex],
          title: `מתפרס עם ${currentTableForSelection}`,
        };
      });

      setShowLoading(true);
      await dispatch(
        editDetails({
          tablesArray: [...updatedTables],
          tables: {
            ...user.tables,
            helpers: helperElements,
            zoomLevel: zoomLevel,
          },
        })
      );
      setShowLoading(false);
      setShowTableSelectionModal(false);
      setFlag(!flag);
      toast.success("הטווח נשמר בהצלחה!");
    } catch (error) {
      setShowLoading(false);
      toast.error("שגיאה בשמירת הטווח");
    }
  };

  // פונקציה להוספה/הסרה של שולחן מהרשימה
  const toggleTableSelection = (tableNum) => {
    const tableStr = tableNum.toString();
    if (selectedTables.includes(tableStr)) {
      setSelectedTables(selectedTables.filter((t) => t !== tableStr));
    } else {
      setSelectedTables([...selectedTables, tableStr]);
    }
  };

  // פונקציה להצגת רשימת אורחים של שולחן
  const showTableGuestsList = () => {
    let guestsForTable = objGuestsByTable[currentTableForSelection] || {};
    let guests = [];
    for (const [key, value] of Object.entries(guestsForTable)) {
      guests.push({
        name: value.name,
        accept: parseInt(value.accept),
        arrived: parseInt(value.arrived) >= 0 ? parseInt(value.arrived) : null,
      });
    }

    setTableGuestsData({
      title: "",
      guests: guests,
      tableNumber: currentTableForSelection,
    });
    setShowTableGuests(true);
    setShowTableContextMenu(false);
  };

  // פונקציה לפתיחת מודל בחירת שולחנות
  const openTableSelectionFromContext = () => {
    if (!currentTableForSelection) {
      toast.error("לא נבחר שולחן עיקרי");
      setShowTableSelectionModal(false);
      setShowTableContextMenu(false);
      return;
    }
    // טעינת השולחנות שכבר נבחרו עבור שולחן זה
    const existingTitle =
      user.tablesArray[currentTableForSelection - 1]?.title || "";

    // בדיקה אם יש כותרת עם "או" או "מתפרס עם"
    if (existingTitle.startsWith("או ")) {
      // חילוץ מספרי השולחנות מהכותרת "או 3, 4"
      const tableNumbers = existingTitle
        .replace("או ", "")
        .split(", ")
        .map((t) => t.trim())
        .filter((t) => t !== "");

      // הוספת השולחן הנוכחי לרשימה
      const allTables = [currentTableForSelection.toString(), ...tableNumbers];
      setSelectedTables(allTables);
    } else if (existingTitle.startsWith("מתפרס עם ")) {
      // אם זה שולחן עם "מתפרס עם", נטען רק את השולחן הנוכחי
      setSelectedTables([currentTableForSelection.toString()]);
    } else {
      // אם אין כותרת מיוחדת, נטען רק את השולחן הנוכחי
      setSelectedTables([currentTableForSelection.toString()]);
    }

    setShowTableSelectionModal(true);
    setShowTableContextMenu(false);
  };

  // פונקציה עזר לבדוק אם שולחן שייך לטווח אחר
  const isTableInOtherRange = (table, idx) => {
    const tableNum = (idx + 1).toString();
    const title = table.title || "";
    // שייך לטווח אחר אם יש לו title של טווח והוא לא חלק מהטווח הנוכחי
    if (
      (title.startsWith("או") || title.startsWith("מתפרס עם")) &&
      !selectedTables.includes(tableNum)
    ) {
      return true;
    }
    return false;
  };

  // פונקציה לחישוב סך העריכות באולם
  const calculateTotalArrived = () => {
    let totalArrived = 0;

    user.tablesArray.forEach((table, idx) => {
      let guestsForTable = objGuestsByTable[idx + 1] || {};

      for (const [key, value] of Object.entries(guestsForTable)) {
        if (parseInt(value.arrived) >= 0) {
          totalArrived += parseInt(value.arrived);
        }
      }
    });

    return totalArrived;
  };

  // פונקציה לחישוב סך ה-amount של כל השולחנות
  const calculateTotalAmount = () => {
    let totalAmount = 0;

    user.tablesArray.forEach((table) => {
      totalAmount += table.amount || 0;
    });

    return totalAmount;
  };

  // פונקציה לחישוב סך ה-arrived בפועל (כל מי שהגיע >= 1)
  const calculateTotalArrivedReal = () => {
    let total = 0;

    // סופרים ישירות מה-guests object
    Object.values(guests).forEach((guest) => {
      // בודקים שהאורח משובץ בשולחן (table > 0) וגם שהגיע (arrived >= 1)
      if (parseInt(guest.table) > 0 && parseInt(guest.arrived) >= 1) {
        total += parseInt(guest.arrived);
      }
    });

    return total;
  };

  // פונקציה להחלפת אורחים בין שולחנות
  const handleSwapTables = async () => {
    if (!swapTable1 || !swapTable2) {
      toast.error("יש להזין שני מספרי שולחנות");
      return;
    }

    const table1Num = parseInt(swapTable1);
    const table2Num = parseInt(swapTable2);

    if (table1Num === table2Num) {
      toast.error("לא ניתן להחליף שולחן עם עצמו");
      return;
    }

    if (
      table1Num < 1 ||
      table1Num > user.tablesArray.length ||
      table2Num < 1 ||
      table2Num > user.tablesArray.length
    ) {
      toast.error("מספרי השולחנות לא תקינים");
      return;
    }

    // איסוף כל האורחים מהשולחן הראשון
    const guestsTable1 = objGuestsByTable[table1Num] || {};
    const guestIdsTable1 = Object.keys(guestsTable1);

    // איסוף כל האורחים מהשולחן השני
    const guestsTable2 = objGuestsByTable[table2Num] || {};
    const guestIdsTable2 = Object.keys(guestsTable2);

    if (guestIdsTable1.length === 0 && guestIdsTable2.length === 0) {
      toast.warn("שני השולחנות ריקים");
      setShowSwapTablesModal(false);
      return;
    }

    try {
      setShowLoading(true);

      // העברת אורחים מהשולחן הראשון לשולחן השני
      if (guestIdsTable1.length > 0) {
        await dispatch(
          editMany({
            ids: guestIdsTable1,
            table: table2Num,
          })
        );
      }

      // העברת אורחים מהשולחן השני לשולחן הראשון
      if (guestIdsTable2.length > 0) {
        await dispatch(
          editMany({
            ids: guestIdsTable2,
            table: table1Num,
          })
        );
      }

      setShowLoading(false);
      setShowSwapTablesModal(false);
      setSwapTable1("");
      setSwapTable2("");
      setFlag(!flag);
      toast.success("החלפת השולחנות בוצעה בהצלחה!");
    } catch (error) {
      setShowLoading(false);
      toast.error("שגיאה בהחלפת השולחנות");
    }
  };

  // פונקציה להעברת אורחים לשולחן אחר
  const handleMoveGuestsToTable = async () => {
    if (!moveToTable) {
      toast.error("אנא הזן מספר שולחן");
      return;
    }

    const targetTable = parseInt(moveToTable);
    if (targetTable < 1 || targetTable > user.tablesArray.length) {
      toast.error("מספר שולחן לא תקין");
      return;
    }

    try {
      // מצא את כל האורחים הנבחרים
      const selectedGuests = Object.entries(multyChoise)
        .filter(([_, isSelected]) => isSelected)
        .map(([guestId, _]) => guestId);

      if (selectedGuests.length === 0) {
        toast.error("לא נבחרו אורחים להעברה");
        return;
      }

      // העבר את האורחים לשולחן החדש
      await dispatch(
        editMany({
          ids: selectedGuests,
          table: targetTable,
        })
      );

      setShowMoveGuestsModal(false);
      setMoveToTable("");
      setFlag(!flag);

      // איפוס הבחירה המרובה
      multyChoise = {};
      multyChoiseCounter = 0;
      setSelected(0);

      // סגירת הפופ אפ של השולחן
      setShowTableGuests(false);

      toast.success(`האורחים הועברו לשולחן ${targetTable} בהצלחה!`);
    } catch (error) {
      console.error("Error moving guests:", error);
      toast.error("שגיאה בהעברת האורחים");
    }
  };

  // פונקציה לביטול שיבוץ (החזרה לאורחים לא משובצים)
  const handleCancelSeating = async () => {
    try {
      // מצא את כל האורחים הנבחרים
      const selectedGuests = Object.entries(multyChoise)
        .filter(([_, isSelected]) => isSelected)
        .map(([guestId, _]) => guestId);

      if (selectedGuests.length === 0) {
        toast.error("לא נבחרו אורחים לביטול שיבוץ");
        return;
      }

      // החזר את האורחים לאורחים לא משובצים (שולחן 0)
      await dispatch(
        editMany({
          ids: selectedGuests,
          table: 0,
        })
      );

      setFlag(!flag);

      // איפוס הבחירה המרובה
      multyChoise = {};
      multyChoiseCounter = 0;
      setSelected(0);

      // סגירת הפופ אפ של השולחן
      setShowTableGuests(false);

      toast.success("האורחים הוחזרו לאורחים לא משובצים בהצלחה!");
    } catch (error) {
      console.error("Error canceling seating:", error);
      toast.error("שגיאה בביטול השיבוץ");
    }
  };

  let helpersArray = useMemo(() => {
    let sortedArray = [];
    let arr = [];

    if (Object.keys(helpers).length > 0) {
      for (const [key, value] of Object.entries(helpers))
        sortedArray.push(value);
      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <div
            key={sortedArray[i]._id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: "15px",
              marginBottom: "10px",
              background: "#f8f9fa",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  {sortedArray[i].name}
                </div>
                <div style={{ color: "#666", fontSize: "12px" }}>
                  נוצר:{" "}
                  {new Date(sortedArray[i].createdAt).toLocaleDateString(
                    "he-IL"
                  )}
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={() => loadHelperSet(sortedArray[i])}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  טען
                </button>
                <button
                  onClick={() => deleteHelperSet(sortedArray[i]._id)}
                  style={{
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  מחק
                </button>
              </div>
            </div>
          </div>
        );
    }
    return arr;
  }, [helpers]);

  return (
    <PopupDiv
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        overflow: "auto",
        background: "white",
        fontSize: "14px",
        borderRadius: "0px",
      }}
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
    >
      {/* setShowMenu */}

      {/* <GenericDiv
        onClick={() => setShowMenu(true)}
        style={{
          borderRadius: "3px",
          padding: "5px",
          position: "absolute",
          top: "0",
          left: "0",
        }}
        background={"#7b96c4"}
      >
        <img src={menu} alt="menu" style={{ width: "21px" }} />
      </GenericDiv>

      <GenericDiv
        onClick={() => init(false)}
        style={{
          borderRadius: "3px",
          padding: "5px",
          position: "absolute",
          top: "0",
          right: "0",
        }}
        background={"#7b96c4"}
      >
        <img src={undo} alt="undo" style={{ width: "21px" }} />
      </GenericDiv> */}

      <div
        style={{
          boxShadow: "0 2px 4px silver",
          width: "100%",
        }}
      >
        <FlexRowBetween
          style={{
            width: "100%",
            margin: "0px",
            alignItems: "flex-start",
          }}
        >
          <GenericDiv
            onClick={() => init(false)}
            style={{
              borderRadius: "0px 0px 0px 7px",
              padding: "5px",
            }}
            background={"#7b96c4"}
          >
            <img src={undo} alt="undo" style={{ width: "23px" }} />
          </GenericDiv>

          {multiSelect ? (
            <FlexRowBetween
              style={{
                width: "min-content",
                margin: "0px",
                alignSelf: "center",
              }}
            >
              <MediumFont>{selected}</MediumFont>
              <input
                type="number"
                min={0}
                max={150}
                onChange={(e) => setTable(e.target.value)}
                className="animate__animated animate__fadeIn"
                style={{ padding: "2px 3px", margin: "0 8px" }}
              />
              <img
                src={sideTable}
                style={{ width: "30px", cursor: "pointer" }}
                onClick={handleEditTableMany}
              />
            </FlexRowBetween>
          ) : (
            <>
              <OverlayTrigger
                placement={"bottom"}
                overlay={<Tooltip>{"נותרו"}</Tooltip>}
              >
                <div
                  onClick={() => setWhat2show("נותרו")}
                  style={{
                    background: "#f2f2f2",
                    padding: "5px 0",
                    paddingRight: "5px",
                    borderBottom: "5px solid #ecac70",
                    cursor: "pointer",
                  }}
                >
                  <FlexRowBetween>
                    <RespFont>{guestsArray[1][1]}</RespFont>
                    <img
                      src={manStand}
                      alt={"manStand"}
                      style={{ width: "20px", marginRight: "3px" }}
                    />
                  </FlexRowBetween>
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                placement={"bottom"}
                overlay={<Tooltip>{"הושבתי"}</Tooltip>}
              >
                <div
                  onClick={() => setWhat2show("הושבתי")}
                  style={{
                    background: "#f2f2f2",
                    padding: "5px",
                    // paddingRight: "5px",
                    borderBottom: "5px solid #7b96c4",
                    cursor: "pointer",
                  }}
                >
                  <FlexRowBetween>
                    <RespFont>{guestsArray[1][0]}</RespFont>
                    <img
                      src={manSeat}
                      alt={"manSeat"}
                      style={{ width: "20px", marginRight: "3px" }}
                    />
                  </FlexRowBetween>
                </div>
              </OverlayTrigger>
            </>
          )}
          <OverlayTrigger
            placement={"bottom"}
            overlay={
              <Tooltip>
                {multiSelect ? "ביטול בחירה מרובה" : "בחירה מרובה"}
              </Tooltip>
            }
          >
            <img
              onClick={() => {
                setMultiSelect(!multiSelect);
                multyChoise = {};
                multyChoiseCounter = 0;
                setSelected(0);
              }}
              src={checklist}
              alt="checklist"
              style={{ width: "30px", cursor: "pointer", alignSelf: "center" }}
            />
          </OverlayTrigger>
          <div
            style={{
              position: "relative",
              width: "110px",
              marginTop: "5px",
            }}
          >
            <PlaceHolderImage
              onClick={() => {
                setSearchText("");
                if (inputRef.current) {
                  inputRef.current.focus();
                }
              }}
              fontSize={`25px`}
              top={`50%`}
              src={clear}
              alt="clear"
              style={{
                cursor: "pointer",
                border: "1px solid silver",
                padding: "5px",
                borderRadius: "2px",
                left: "7px",
              }}
            />
            <Input
              value={searchText}
              ref={inputRef}
              type="text"
              placeholder="חיפוש"
              name="value"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "5px 0px",
                paddingRight: "3px",
                border: "1px solid silver",
              }}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          {showTableArrange == false && (
            <div style={{ marginRight: "10px" }}>
              <BurgerMenu
                isOpen={isMainMenuBurgerOpen}
                onToggle={() => setIsMainMenuBurgerOpen(!isMainMenuBurgerOpen)}
              >
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="עריכת שולחנות"
                  onClick={() => {
                    setEditTables(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#6f42c1"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M19 7l-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="מחיקת שולחנות"
                  onClick={() => {
                    if (user.canSeatExtra) {
                      setDeleteTables(true);
                      setIsMainMenuBurgerOpen(false);
                    } else {
                      toast.error(
                        "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות"
                      );
                    }
                  }}
                  color="#dc3545"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14M5 12h14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הוספת שולחנות"
                  onClick={() => {
                    if (user.canSeatExtra) {
                      setAddTables(true);
                      setIsMainMenuBurgerOpen(false);
                    } else {
                      toast.error(
                        "מנהל ההושבה שלך סגר את האופציה להוספת שולחנות"
                      );
                    }
                  }}
                  color="#28a745"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 7V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 13l2 2 4-4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הושבה עם סקיצה"
                  onClick={() => {
                    handleOpenArrange();
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#17a2b8"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M7 16V4M17 20V8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3 8L7 4L11 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 16L17 20L13 16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="החלפה"
                  onClick={() => {
                    setShowSwapTablesModal(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#6f42c1"
                />

                {user.sketch === "" ? (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <polyline
                          points="7,9 12,4 17,9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="12"
                          y1="4"
                          x2="12"
                          y2="20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="העלאת סקיצה"
                    onClick={() => {
                      setEditSketch(true);
                      setIsMainMenuBurgerOpen(false);
                    }}
                    color="#17a2b8"
                  />
                ) : (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3 6h18"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="מחיקת סקיצה"
                    onClick={() => {
                      deletePhotoOnly();
                      setIsMainMenuBurgerOpen(false);
                    }}
                    color="#dc3545"
                  />
                )}

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="8.5"
                        cy="7"
                        r="4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M20 8v6M23 11h-6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הוספת אורח להושבה"
                  onClick={() => {
                    setShowAddGuest(true);
                    setIsMainMenuBurgerOpen(false);
                  }}
                  color="#ffc107"
                />
              </BurgerMenu>
            </div>
          )}
          {/* <button
            style={{
              margin: 8,
              padding: "6px 16px",
              background: "#5377bb",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
            onClick={handleOpenArrange}
          >
            ערוך מיקום שולחנות
          </button> */}
        </FlexRowBetween>
        <FlexRowBetween
          style={{
            width: "96%",
            margin: "0px auto",
            overflowX: "auto",
            justifyContent: "flex-start",
          }}
        >
          {cats}
        </FlexRowBetween>
      </div>

      <FlexRowBetween
        style={{
          maxHeight: `${window.screen.availHeight - 110}px`,
          overflow: "auto",
        }}
      >
        <div
          style={{
            overflow: "auto",
            height: "100%",
            width: widthS > 768 ? "20%" : "40%",
          }}
        >
          <ListHolder style={{ height: "100%" }}>{[guestsArray[0]]}</ListHolder>
        </div>

        <div
          style={{
            width: widthS > 768 ? "80%" : "60%",
            overflow: "auto",
            height: "100%",
          }}
        >
          <ListHolder style={{ height: "100%" }}>{[tablesArray[0]]}</ListHolder>
        </div>
      </FlexRowBetween>
      {isTal && (
        <FlexRowBetween
          // onClick={() => setAddArticle(true)}
          style={{
            width: "min-content",
            border: "2px solid rgba(0, 0, 0, 0.11)",
            borderRadius: "50px",
            padding: "3px",
            position: "absolute",
            // fontWeight: "700",
            // marginRight: "30px",
            cursor: "pointer",
            bottom: "30px",
            left: "20px",
          }}
        >
          <div
            onClick={() => handleGetAll()}
            style={{
              padding: "7px 7px",
              backgroundColor: "#7b96c4",
              transition: "all 0.2s",
              borderRadius: "50px",
              color: "white",
              width: "max-content",
              fontSize: "18px",
              position: "relative",
            }}
          >
            {guestsLoading ? (
              <img src={spinner} width="50" alt="spinner" />
            ) : (
              parseInt(guestsArray[1][2]) - 1
            )}
            {/* {guestsLoading && <SmallLoading />} */}
            {/* {parseInt(guestsArray[1][2]) - 1} */}
            {/* <img src={plus} style={{width:"20px"}} /> */}
          </div>
        </FlexRowBetween>
        // <div
        //   className="animate__animated animate__pulse animate__repeat-2"
        //   style={{
        //     position: "absolute",
        //     border: "2px solid black",
        //     bottom: "20px",
        //     left: "20px",
        //     zIndex: 1,
        //   }}
        // >
        //   {parseInt(guestsArray[1][2]) - 1}
        // </div>
      )}
      {showLoading && <OpacityLoading />}

      {addTables && (
        <GenericModal
          init={setAddTables}
          div={<AddTables init={setAddTables} />}
        />
      )}

      {editTables && (
        <GenericModal
          init={setEditTables}
          div={<EditTables init={setEditTables} />}
        />
      )}

      {deleteTables && (
        <GenericModal
          init={setDeleteTables}
          div={<DeleteTables init={setDeleteTables} />}
        />
      )}

      {editSketch && (
        <GenericModal
          init={setEditSketch}
          div={<EditPics init={setEditSketch} kind={"sketch"} id={user._id} />}
        />
      )}

      {showSketch && (
        <GenericModal
          init={setShowSketch}
          div={
            <img
              src={`${getImageUrl()}${user._id}/${user.sketch}`}
              style={{ width: "auto", height: "100%" }}
            />
          }
        />
      )}

      {showAddGuest && (
        <GenericModal
          init={setShowAddGuest}
          div={<AddG2T init={setShowAddGuest} handleGetAll={handleGetAll} />}
        />
      )}

      {showTableArrange && (
        <GenericModal
          init={() => handleCloseTableArrange()}
          div={
            <div
              onClick={(e) => {
                e.stopPropagation();
                setIsBurgerMenuOpen(false);
              }}
              style={{
                width: "100vw",
                height: "100vh",
                position: "relative",
                background: "#f7f7f7",
                overflow: "auto",
                padding: 24,
              }}
            >
              {showGuestsList ? (
                <div
                  style={{
                    overflow: "auto",
                    height: "100%",
                    width: widthS > 768 ? "20%" : "40%",
                    position: "absolute",
                    background: "#fff",
                    boxShadow: "0 -2px 4px #949393",
                    top: 0,
                    right: 0,
                    zIndex: 2,
                  }}
                >
                  <FlexRowBetween>
                    {multiSelect ? (
                      <FlexRowBetween
                        style={{
                          width: "min-content",
                          margin: "0px",
                          alignSelf: "center",
                        }}
                      >
                        <MediumFont style={{ marginRight: "5px" }}>
                          {selected}
                        </MediumFont>
                        <input
                          type="number"
                          min={0}
                          max={150}
                          onChange={(e) => setTable(e.target.value)}
                          className="animate__animated animate__fadeIn"
                          style={{ padding: "2px 3px", margin: "0 8px" }}
                        />
                        <img
                          src={sideTable}
                          style={{ width: "30px", cursor: "pointer" }}
                          onClick={handleEditTableMany}
                        />
                      </FlexRowBetween>
                    ) : (
                      <FlexRowStart
                        style={{ width: "fit-content", marginRight: "0" }}
                      >
                        <OverlayTrigger
                          placement={"bottom"}
                          overlay={<Tooltip>{"נותרו"}</Tooltip>}
                        >
                          <div
                            onClick={() => setWhat2show("נותרו")}
                            style={{
                              background: "#f2f2f2",
                              padding: "5px 0",
                              paddingRight: "5px",
                              borderBottom: "5px solid #ecac70",
                              cursor: "pointer",
                            }}
                          >
                            <FlexRowBetween>
                              <RespFont>{guestsArray[1][1]}</RespFont>
                              <img
                                src={manStand}
                                alt={"manStand"}
                                style={{ width: "20px", marginRight: "3px" }}
                              />
                            </FlexRowBetween>
                          </div>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement={"bottom"}
                          overlay={<Tooltip>{"הושבתי"}</Tooltip>}
                        >
                          <div
                            onClick={() => setWhat2show("הושבתי")}
                            style={{
                              background: "#f2f2f2",
                              padding: "5px",
                              marginRight: "25px",
                              borderBottom: "5px solid #7b96c4",
                              cursor: "pointer",
                            }}
                          >
                            <FlexRowBetween>
                              <RespFont>{guestsArray[1][0]}</RespFont>
                              <img
                                src={manSeat}
                                alt={"manSeat"}
                                style={{ width: "20px", marginRight: "3px" }}
                              />
                            </FlexRowBetween>
                          </div>
                        </OverlayTrigger>
                      </FlexRowStart>
                    )}

                    <OverlayTrigger
                      placement={"bottom"}
                      overlay={
                        <Tooltip>
                          {multiSelect ? "ביטול בחירה מרובה" : "בחירה מרובה"}
                        </Tooltip>
                      }
                    >
                      <img
                        onClick={() => {
                          setMultiSelect(!multiSelect);
                          multyChoise = {};
                          multyChoiseCounter = 0;
                          setSelected(0);
                        }}
                        src={checklist}
                        alt="checklist"
                        style={{
                          width: "30px",
                          cursor: "pointer",
                          alignSelf: "center",
                          marginLeft: "25px",
                        }}
                      />
                    </OverlayTrigger>
                    <div
                      style={{
                        position: "relative",
                        width: "110px",
                        marginTop: "5px",
                      }}
                    >
                      <PlaceHolderImage
                        onClick={() => {
                          setSearchText("");
                          if (inputRef.current) {
                            inputRef.current.focus();
                          }
                        }}
                        fontSize={`25px`}
                        top={`50%`}
                        src={clear}
                        alt="clear"
                        style={{
                          cursor: "pointer",
                          border: "1px solid silver",
                          padding: "5px",
                          borderRadius: "2px",
                          left: "7px",
                        }}
                      />
                      <Input
                        value={searchText}
                        ref={inputRef}
                        type="text"
                        placeholder="חיפוש"
                        name="value"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          padding: "5px 0px",
                          paddingRight: "3px",
                          border: "1px solid silver",
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </FlexRowBetween>

                  <ListHolder style={{ height: "100%" }}>
                    {[guestsArray[0]]}
                  </ListHolder>
                </div>
              ) : null}
              {/* תפריט בורגר */}
              <BurgerMenu
                isOpen={isBurgerMenuOpen}
                onToggle={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
                position="absolute"
                top="16px"
                left="16px"
              >
                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 6L6 18M6 6l12 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="סגור"
                  onClick={() => {
                    handleCloseTableArrange();
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#dc3545"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <polyline
                        points="17,21 17,13 7,13 7,21"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <polyline
                        points="7,3 7,8 15,8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="שמור הכל"
                  onClick={() => {
                    if (user.canSeatExtra) {
                      handleSaveTablePositions();
                      setIsBurgerMenuOpen(false);
                    } else {
                      toast.error(
                        "מנהל ההושבה שלך סגר את האופציה לעריכת הסקיצה"
                      );
                    }
                  }}
                  color="#5377bb"
                />

                {/* <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 6L6 18M6 6l12 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="סגור"
                  onClick={() => {
                    handleCloseTableArrange();
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#6c757d"
                /> */}

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="15"
                        y="3"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="3"
                        y="15"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <rect
                        x="15"
                        y="15"
                        width="6"
                        height="6"
                        rx="1"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="9"
                        y1="6"
                        x2="15"
                        y2="6"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="9"
                        y1="18"
                        x2="15"
                        y2="18"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="6"
                        y1="9"
                        x2="6"
                        y2="15"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="18"
                        y1="9"
                        x2="18"
                        y2="15"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  }
                  text="טווחים"
                  onClick={() => {
                    setShowRangesModal(true);
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#007bff"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M7 16V4M17 20V8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3 8L7 4L11 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 16L17 20L13 16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="החלפה"
                  onClick={() => {
                    setShowSwapTablesModal(true);
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#6f42c1"
                />

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="עריכת שולחנות"
                  onClick={() => {
                    setEditTables(true);
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#6f42c1"
                />

                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M17 11V7a5 5 0 0 0-10 0v4M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text={tablesLocked ? "בטל נעילה" : "נעל שולחנות"}
                    onClick={() => {
                      setTablesLocked(!tablesLocked);
                      setIsBurgerMenuOpen(false);
                    }}
                    color={tablesLocked ? "#dc3545" : "#28a745"}
                  />
                )}

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <circle
                        cx="8.5"
                        cy="8.5"
                        r="1.5"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <polyline
                        points="21,15 16,10 5,21"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text={showSketchBackground ? "הסתר סקיצה" : "הצג סקיצה"}
                  onClick={() => {
                    setShowSketchBackground(!showSketchBackground);
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#17a2b8"
                />
                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <polyline
                          points="17,21 17,13 7,13 7,21"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <polyline
                          points="7,3 7,8 15,8"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="שמור מערך"
                    onClick={() => {
                      setShowSaveSetModal(true);
                      setIsBurgerMenuOpen(false);
                    }}
                    color="#ffc107"
                  />
                )}
                {isTal && (
                  <MenuItem
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3 7V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 13l2 2 4-4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    text="מערכים שמורים"
                    onClick={() => {
                      setShowSavedSetsModal(true);
                      setIsBurgerMenuOpen(false);
                    }}
                    color="#6f42c1"
                  />
                )}

                <MenuItem
                  icon={
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14M5 12h14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  text="הוסף עזר"
                  onClick={() => {
                    setEditingHelper(null);
                    setNewHelperTitle("");
                    setNewHelperColor("#4c6daf");
                    setNewHelperBgColor(
                      getBackgroundColorWithOpacity("#4c6daf")
                    );
                    setNewHelperTextAlign("center");
                    setNewHelperFontSize(18);
                    setShowHelperModal(true);
                    setIsBurgerMenuOpen(false);
                  }}
                  color="#28a745"
                />
              </BurgerMenu>
              {/* <button
                  style={{
                    position: "absolute",
                    top: 16,
                  left: 281,
                    zIndex: 2,
                  background: showGuestsList ? "#6c757d" : "#17a2b8",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                onClick={() => setShowGuestsList(!showGuestsList)}
              >
                {showGuestsList ? "הסתר אורחים" : "הצג אורחים"}
              </button> */}

              {/* {false && (
                <button
                  style={{
                    position: "absolute",
                    top: 16,
                    left: 560,
                    zIndex: 2,
                    background: reception ? "#17a2b8" : "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onClick={() => setReception(!reception)}
                  title={reception ? "מעבר למי כאן?" : "מעבר לקבלת פנים"}
                >
                  {reception ? "מי כאן?" : "קבלת פנים"}
                </button>
              )} */}

              {/* `${zoomLevel}` */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  backgroundImage: showSketchBackground
                    ? `url(${getImageUrl()}${user._id}/${user.sketch})`
                    : `
                      linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px),
                      linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)
                    `,
                  backgroundSize: showSketchBackground
                    ? `${scetchSize * 1.2 * zoomLevel}px`
                    : "30px 30px",
                  backgroundRepeat: showSketchBackground
                    ? "no-repeat"
                    : "repeat",
                  backgroundPosition: showSketchBackground
                    ? "left 30px top"
                    : "left 30px top",
                  backgroundColor: showSketchBackground
                    ? "rgba(255,255,255,0.9)"
                    : "transparent",
                }}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
              >
                {/* Helper Elements */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    transform: `scale(${zoomLevel})`,
                    transformOrigin: "top left",
                  }}
                >
                  {Object.entries(helperElements).map(
                    ([helperType, helper]) => (
                      <div
                        key={helperType}
                        onMouseDown={(e) =>
                          handleHelperMouseDown(helperType, e)
                        }
                        onContextMenu={(e) =>
                          handleHelperRightClick(helperType, e)
                        }
                        style={{
                          position: "absolute",
                          left: helper.x,
                          top: helper.y,
                          width: helper.width,
                          height: helper.height,
                          background: helper.backgroundColor,
                          border: `2px solid ${helper.color}`,
                          borderRadius: 6,
                          display: "flex",
                          alignItems:
                            helper.textAlign === "flex-start"
                              ? "flex-start"
                              : helper.textAlign === "flex-end"
                              ? "flex-end"
                              : "center",
                          justifyContent: "center",
                          fontSize: helper.fontSize || 12,
                          fontWeight: "bold",
                          color: helper.color,
                          cursor: tablesLocked
                            ? "not-allowed"
                            : draggedHelper === helperType
                            ? "grabbing"
                            : "grab",
                          userSelect: "none",
                          zIndex: draggedHelper === helperType ? 10 : 1,
                          transition:
                            draggedHelper === helperType
                              ? "none"
                              : "box-shadow 0.2s",
                          padding:
                            helper.textAlign === "flex-start" ||
                            helper.textAlign === "flex-end"
                              ? "8px"
                              : "0",
                          transform: `rotate(${helper.rotation || 0}deg)`,
                        }}
                      >
                        {helper.title}
                        {!tablesLocked && (
                          <div
                            className="helper-rotate-handle"
                            onMouseDown={(e) =>
                              handleHelperRotateMouseDown(helperType, e)
                            }
                            style={{
                              position: "absolute",
                              top: "-20px",
                              right: "-20px",
                              width: "16px",
                              height: "16px",
                              background: "#007bff",
                              borderRadius: "50%",
                              border: "2px solid white",
                              cursor: "grab",
                              zIndex: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              color: "white",
                              fontWeight: "bold",
                            }}
                            title="סובב עזר"
                          >
                            ↻
                          </div>
                        )}
                        {!tablesLocked && (
                          <div
                            className="helper-resize-handle"
                            onMouseDown={(e) =>
                              handleHelperResizeMouseDown(helperType, e)
                            }
                            style={{
                              position: "absolute",
                              right: "-4px",
                              bottom: "-4px",
                              width: 12,
                              height: 12,
                              background: helper.color,
                              borderRadius: "0 0 6px 0",
                              border: `1px solid ${helper.color}`,
                              cursor: "nwse-resize",
                              zIndex: 20,
                            }}
                          />
                        )}
                      </div>
                    )
                  )}

                  {/* Tables */}
                  {user.tablesArray.map((table, idx) => {
                    let guestsForTable = objGuestsByTable[idx + 1] || {};
                    let count = 0;
                    let arrived = 0;
                    for (const [key, value] of Object.entries(guestsForTable)) {
                      count += parseInt(value.accept);
                      if (parseInt(value.arrived) >= 0) {
                        // סכום כל מי שהגיע בפועל
                        arrived += parseInt(value.arrived);
                      }
                    }
                    const max = isTal
                      ? table.chairs || table.amount
                      : table.amount;
                    const displayCount = isTal ? arrived : count;
                    let fillRatio = max > 0 ? displayCount / max : 0;
                    let borderColor = "#5377bb";

                    // Check if this is a reserve table
                    const isReserveTable = table.title === "רזרבה";

                    if (isReserveTable) {
                      borderColor = "#000000"; // Black border for reserve tables
                    } else if (displayCount > max) {
                      borderColor = "#f66a6a";
                    } else if (fillRatio === 1) {
                      borderColor = "#a9dc58";
                    } else {
                      borderColor = "#ecac70";
                    }

                    return (
                      <div
                        key={idx}
                        onMouseDown={(e) => {
                          handleTableMouseDown(e, idx);
                        }}
                        onClick={(e) => {
                          // הצג אורחים רק כשהשולחנות נעולים
                          if (
                            tablesLocked &&
                            e.target.className !== "resize-handle" &&
                            draggedTable === null
                          ) {
                            let guestsForTable =
                              objGuestsByTable[idx + 1] || {};
                            let guests = [];
                            for (const [key, value] of Object.entries(
                              guestsForTable
                            )) {
                              const displayAccept = parseInt(value.accept);
                              guests.push({
                                name: value.name,
                                accept: displayAccept,
                              });
                            }
                            setTableGuestsData({
                              title: "",
                              guests: guests,
                              tableNumber: idx + 1,
                            });
                            setShowTableGuests(true);
                          }
                        }}
                        onContextMenu={(e) => handleTableRightClick(idx, e)}
                        style={{
                          position: "absolute",
                          left: tablesPositions[idx].x,
                          top: tablesPositions[idx].y,
                          width: tablesPositions[idx].width,
                          height: tablesPositions[idx].height,
                          background: blinkingTables.includes(idx + 1)
                            ? "#f8f0ff"
                            : "#fff",
                          border: `4px solid ${
                            blinkingTables.includes(idx + 1)
                              ? "#8b5cf6"
                              : borderColor
                          }`,
                          borderRadius:
                            tablesPositions[idx].shape === "circle" ? "50%" : 8,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "space-between",
                          fontWeight: "bold",
                          fontSize: 12,
                          boxShadow: blinkingTables.includes(idx + 1)
                            ? "0 0 25px rgba(139, 92, 246, 0.9)"
                            : "0 2px 8px rgba(0,0,0,0.08)",
                          cursor: tablesLocked
                            ? "pointer"
                            : draggedTable === idx
                            ? "grabbing"
                            : "grab",
                          userSelect: "none",
                          zIndex: blinkingTables.includes(idx + 1)
                            ? 15
                            : draggedTable === idx
                            ? 10
                            : user.tablesArray.length - idx,
                          transition:
                            draggedTable === idx ? "none" : "box-shadow 0.2s",
                          animation: blinkingTables.includes(idx + 1)
                            ? "blink 0.8s infinite"
                            : "none",
                          transform: `rotate(${tablesPositions[idx].rotation}deg)`,
                          // padding: 2,
                        }}
                      >
                        {!tablesLocked && (
                          <div
                            className="rotate-handle"
                            onMouseDown={(e) => handleRotateMouseDown(e, idx)}
                            style={{
                              position: "absolute",
                              top: "-20px",
                              right: "-20px",
                              width: "16px",
                              height: "16px",
                              background: "#007bff",
                              borderRadius: "50%",
                              border: "2px solid white",
                              cursor: "grab",
                              zIndex: 20,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              color: "white",
                              fontWeight: "bold",
                            }}
                            title="סובב שולחן"
                          >
                            ↻
                          </div>
                        )}
                        {isReserveTable ? (
                          <div
                            style={{
                              fontSize: 13,
                              color: blinkingTables.includes(idx + 1)
                                ? "#8b5cf6"
                                : "#000000",
                              fontWeight: "bold",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            רזרבה
                          </div>
                        ) : (
                          <div
                            style={{
                              fontSize: 18,
                              color: blinkingTables.includes(idx + 1)
                                ? "#8b5cf6"
                                : "#000",
                            }}
                          >
                            {displayCount}/{max}
                          </div>
                        )}
                        <div
                          style={{
                            fontSize: 22,
                            fontWeight: 700,
                            minWidth: 32,
                            textAlign: "center",
                            color: blinkingTables.includes(idx + 1)
                              ? "#8b5cf6"
                              : "#000",
                          }}
                        >
                          {idx + 1}
                        </div>

                        {!tablesLocked && (
                          <div
                            className="resize-handle"
                            onMouseDown={(e) => handleResizeMouseDown(e, idx)}
                            style={{
                              position: "absolute",
                              right: "-4px",
                              bottom: "-4px",
                              width: 15,
                              height: 15,
                              background: "#eee",
                              borderRadius: "0 0 8px 0",
                              borderTop: "1px solid #ccc",
                              borderLeft: "1px solid #ccc",
                              border: "1px solid #ccc",
                              cursor: "nwse-resize",
                              zIndex: 20,
                            }}
                          />
                        )}
                        {/* סימן קטן ליד שולחנות מסומנים */}
                        {(blinkingTables.includes(idx + 1) ||
                          markedTables.includes(idx + 1)) && (
                          <div
                            style={{
                              position: "absolute",
                              top: "-8px",
                              right: "-8px",
                              width: "16px",
                              height: "16px",
                              background: "#8b5cf6",
                              borderRadius: "50%",
                              border: "2px solid white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                              zIndex: 25,
                            }}
                          />
                        )}
                        {/* עיגול טווח צבעוני בפינה שמאל-תחתון */}
                        {(table.title?.startsWith("או") ||
                          table.title?.startsWith("מתפרס עם ")) &&
                          tableToRangeColorIdx[(idx + 1).toString()] !==
                            undefined && (
                            <div
                              style={{
                                position: "absolute",
                                left: -4,
                                bottom: -4,
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                                background:
                                  RANGE_COLORS[
                                    tableToRangeColorIdx[(idx + 1).toString()]
                                  ],
                                border: "2px solid #fff",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                                zIndex: 30,
                                cursor: "pointer",
                              }}
                              title={`שייך לטווח: ${Object.values(tableRanges)
                                .find((g) => g.includes((idx + 1).toString()))
                                ?.join(", ")}`}
                            />
                          )}
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* Zoom Controls */}
              <div
                style={{
                  position: "absolute",
                  bottom: 16,
                  left: 16,
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {/* סך ה-arrived בפועל - מוצג רק ל-isTal */}
                {isTal && (
                  <div
                    style={{
                      background: "#5c86ce",
                      color: "white",
                      padding: "4px 6px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      textAlign: "center",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    title="סך האורחים שהגיעו בפועל"
                  >
                    <div style={{ fontSize: "16px" }}>
                      {/* {calculateTotalArrivedReal()} */}
                      {parseInt(guestsArray[1][2]) - 1}
                    </div>
                    <div style={{ fontSize: "12px", marginBottom: "2px" }}>
                      הגיעו
                    </div>
                  </div>
                )}
                {/* סך ה-amount - מוצג רק ל-isTal */}
                {isTal && (
                  <div
                    style={{
                      background: "rgba(0, 0, 0, 0.8)",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      textAlign: "center",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      marginTop: "4px",
                    }}
                    title="סך ה-amount של כל השולחנות"
                  >
                    <div style={{ fontSize: "12px", marginBottom: "2px" }}>
                      עריכות
                    </div>
                    <div style={{ fontSize: "16px" }}>
                      {calculateTotalAmount()}
                    </div>
                  </div>
                )}
                <button
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px",
                    cursor: "pointer",
                    fontSize: 14,
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleZoomIn}
                  title="הגדל"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 5v14M5 12h14"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px",
                    cursor: "pointer",
                    fontSize: 14,
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleZoomOut}
                  title="הקטן"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12h14"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div
                  style={{
                    background: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: 4,
                    fontSize: "12px",
                    textAlign: "center",
                    minWidth: "36px",
                  }}
                >
                  {Math.round(zoomLevel * 100)}%
                </div>
              </div>

              {/* Save Helper Set Button */}
              {isTal && (
                <div
                  style={{
                    position: "absolute",
                    top: 16,
                    left: 718,
                    zIndex: 2,
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {showNameInput ? (
                    <>
                      <input
                        type="text"
                        value={customSetName}
                        onChange={(e) => setCustomSetName(e.target.value)}
                        placeholder="שם המערך..."
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: 4,
                          fontSize: 14,
                          width: 150,
                        }}
                        onKeyPress={(e) =>
                          e.key === "Enter" && saveCurrentHelperSet()
                        }
                      />
                      <button
                        onClick={saveCurrentHelperSet}
                        style={{
                          background: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                      >
                        שמור
                      </button>
                      <button
                        onClick={() => {
                          setShowNameInput(false);
                          setCustomSetName("");
                        }}
                        style={{
                          background: "#6c757d",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                      >
                        ביטול
                      </button>
                    </>
                  ) : null}
                </div>
              )}
              {/* Load Saved Sets Button */}
              {/* {isTal && savedHelperSets.length > 0 && (
                <button
                  style={{
                    position: "absolute",
                    top: 16,
                    left: 490,
                    zIndex: 2,
                    background: "#6f42c1",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 14,
                  }}
                  onClick={() => setShowSavedSetsModal(true)}
                >
                  📋 מערכים שמורים ({savedHelperSets.length})
                </button>
              )} */}
            </div>
          }
        />
      )}

      {showHelperModal && (
        <GenericModal
          init={() => setShowHelperModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 350,
                maxHeight: 600,
                background: "#fff",
                borderRadius: 10,
                padding: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>
                {editingHelper ? "עריכת עזר" : "הוספת עזר חדש"}
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  כותרת:
                </label>
                <input
                  type="text"
                  value={newHelperTitle}
                  onChange={(e) => setNewHelperTitle(e.target.value)}
                  placeholder="כותרת"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                  }}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  צבע:
                </label>
                <input
                  type="color"
                  value={newHelperColor}
                  onChange={(e) => {
                    setNewHelperColor(e.target.value);
                    setNewHelperBgColor(
                      getBackgroundColorWithOpacity(e.target.value)
                    );
                  }}
                  style={{ width: "100%", height: 40 }}
                />
                <small style={{ color: "#666", fontSize: "12px" }}>
                  צבע הרקע יותאם אוטומטית בגרסה עדינה יותר
                </small>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  מיקום כותרת:
                </label>
                <select
                  value={newHelperTextAlign}
                  onChange={(e) => setNewHelperTextAlign(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                  }}
                >
                  <option value="center">מרכז</option>
                  <option value="flex-start">חלק עליון</option>
                  <option value="flex-end">חלק תחתון</option>
                </select>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: 5,
                    fontWeight: "bold",
                  }}
                >
                  גודל כותרת:
                </label>
                <input
                  type="range"
                  min="18"
                  max="36"
                  value={newHelperFontSize}
                  onChange={(e) =>
                    setNewHelperFontSize(parseInt(e.target.value))
                  }
                  style={{ width: "100%" }}
                />
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px",
                  }}
                >
                  {newHelperFontSize}px
                </div>
              </div>
              <div style={{ marginBottom: 20, marginTop: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <button
                    onClick={
                      editingHelper ? handleSaveHelper : handleAddNewHelper
                    }
                    style={{
                      background: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    {editingHelper ? "שמור" : "הוסף"}
                  </button>
                  {editingHelper && (
                    <>
                      <button
                        onClick={() => handleBringToFront(editingHelper)}
                        style={{
                          background: "#8b5cf6",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "bold",
                          flex: 1,
                          marginRight: "8px",
                        }}
                      >
                        להביא לקידמה
                      </button>
                      <button
                        onClick={handleDeleteHelper}
                        style={{
                          background: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                      >
                        מחק
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          }
        />
      )}

      {/* פופאפ אורחים בשולחן */}
      {showTableGuests && (
        <ClearModal
          init={() => setShowTableGuests(false)}
          div={
            <div
              style={{
                width: 320,
                maxHeight: 500,
                background: "#fff",
                borderRadius: 10,
                padding: 18,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>
                {tableGuestsData.tableNumber} -{" "}
                {user.tablesArray[tableGuestsData.tableNumber - 1]?.title ||
                  "שולחן"}
              </div>
              {isTal && tableGuestsData.guests.length > 0 && (
                <div
                  style={{
                    marginBottom: 10,
                    padding: "8px 12px",
                    background: "#f8f9fa",
                    borderRadius: 4,
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  ערוך:{" "}
                  {user.tablesArray[tableGuestsData.tableNumber - 1]?.amount ||
                    0}{" "}
                  / הושבו:{" "}
                  {(() => {
                    let guestsForTable =
                      objGuestsByTable[tableGuestsData.tableNumber] || {};
                    let totalAccept = 0;
                    for (const [key, value] of Object.entries(guestsForTable)) {
                      totalAccept += parseInt(value.accept);
                    }
                    return totalAccept;
                  })()}
                </div>
              )}
              {multiSelect && tableGuestsData.guests.length > 0 && (
                <div style={{ marginBottom: 10 }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      addOrDeleteAllTable(tableGuestsData.tableNumber);
                    }}
                    style={{
                      background: areAllGuestsInTableSelected(
                        tableGuestsData.tableNumber
                      )
                        ? "#dc3545"
                        : "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "8px 16px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    title={
                      areAllGuestsInTableSelected(tableGuestsData.tableNumber)
                        ? "בטל בחירת כל האורחים בשולחן"
                        : "בחר את כל האורחים בשולחן"
                    }
                  >
                    {areAllGuestsInTableSelected(tableGuestsData.tableNumber)
                      ? "בטל בחירת כל האורחים"
                      : "בחר את כל האורחים בשולחן"}
                  </button>

                  {/* כפתורים נוספים כאשר יש אורחים נבחרים */}
                  {Object.values(multyChoise).some(
                    (isSelected) => isSelected
                  ) && (
                    <div style={{ marginTop: 8, display: "flex", gap: "8px" }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowMoveGuestsModal(true);
                        }}
                        style={{
                          background: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: 4,
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                        title="העבר אורחים נבחרים לשולחן אחר"
                      >
                        העברה לשולחן אחר
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCancelSeating();
                        }}
                        style={{
                          background: "#ffc107",
                          color: "black",
                          border: "none",
                          borderRadius: 4,
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                          flex: 1,
                        }}
                        title="החזר אורחים נבחרים לאורחים לא משובצים"
                      >
                        ביטול שיבוץ
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div style={{ maxHeight: 250, overflowY: "auto" }}>
                {tableGuestsData.guests.length === 0 ? (
                  <div style={{ color: "#888", textAlign: "center" }}>
                    אין אורחים בשולחן זה
                  </div>
                ) : (
                  <>
                    {tableGuestsData.guests.map((g, i) => {
                      // מצא את האורח המקורי לפי השם
                      const originalGuest = Object.values(guests).find(
                        (guest) =>
                          guest.name === g.name &&
                          guest.table === tableGuestsData.tableNumber
                      );

                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #eee",
                            padding: "8px 0",
                            background:
                              multiSelect &&
                              originalGuest &&
                              multyChoise[originalGuest._id]
                                ? "#c1d1eb79"
                                : "inherit",
                            cursor:
                              multiSelect && originalGuest
                                ? "pointer"
                                : "default",
                          }}
                          onClick={(e) => {
                            if (multiSelect && originalGuest) {
                              e.stopPropagation();
                              add_del(originalGuest._id, originalGuest.accept);
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span>{g.name}</span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {/* {isTal?} */}
                            <span style={{ fontWeight: 600 }}>
                              {/* {g.accept} */}
                              {isTal && originalGuest.arrived !== null
                                ? `${g.accept} / ${originalGuest.arrived}`
                                : g.accept}
                            </span>
                            {/* {isTal &&
                                g.arrived !== null &&
                                parseInt(g.arrived) > 0 && (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      background: "#e9ecef",
                                      padding: "2px 6px",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    {g.arrived}/{g.accept}
                                  </span>
                                )} */}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{ padding: "20px 0" }}></div>
                  </>
                )}
              </div>
            </div>
          }
        />
      )}

      {/* Table Management Modals - Available in Table Arrange Mode */}
      {showTableArrange && editTables && (
        <GenericModal
          init={setEditTables}
          div={<EditTables init={handleEditTables} />}
        />
      )}

      {showTableArrange && addTables && (
        <GenericModal
          init={setAddTables}
          div={<AddTables init={setAddTables} />}
        />
      )}

      {showTableArrange && deleteTables && (
        <GenericModal
          init={setDeleteTables}
          div={<DeleteTables init={setDeleteTables} />}
        />
      )}

      {/* Modal for Saved Helper Sets */}
      {showSavedSetsModal && (
        <GenericModal
          init={() => setShowSavedSetsModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 500,
                maxHeight: 600,
                background: "#fff",
                borderRadius: 10,
                padding: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}>
                מערכי עזרים שמורים
              </div>
              <div style={{ maxHeight: 400, overflowY: "auto" }}>
                {helpersArray.length == 0 ? (
                  <div
                    style={{
                      color: "#888",
                      textAlign: "center",
                      padding: "20px",
                    }}
                  >
                    אין מערכי עזרים שמורים
                  </div>
                ) : (
                  helpersArray
                )}
              </div>
            </div>
          }
        />
      )}

      {/* תפריט קליק ימני לשולחן */}
      {showTableContextMenu && (
        <GenericModal
          init={() => setShowTableContextMenu(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: 300,
                background: "#fff",
                borderRadius: 10,
                padding: 0,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  background: "#f8f9fa",
                  padding: "15px 20px",
                  borderBottom: "1px solid #dee2e6",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                שולחן {currentTableForSelection}
              </div>
            </div>
          }
        />
      )}

      {showTableSelectionModal && (
        <GenericModal
          init={() => setShowTableSelectionModal(false)}
          div={
            !currentTableForSelection ? (
              <div
                style={{
                  color: "red",
                  padding: 40,
                  fontSize: 18,
                  textAlign: "center",
                }}
              >
                לא נבחר שולחן עיקרי
              </div>
            ) : (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: 500,
                  maxHeight: 600,
                  background: "#fff",
                  borderRadius: 10,
                  padding: 20,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}
                >
                  בחירת שולחנות עבור שולחן {currentTableForSelection}
                </div>

                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontWeight: "bold", marginBottom: 10 }}>
                    שולחנות נבחרים:{" "}
                    {selectedTables.length > 0
                      ? selectedTables.join(", ")
                      : "אין"}
                  </div>

                  <div
                    style={{
                      maxHeight: 300,
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: 8,
                      padding: 10,
                    }}
                  >
                    {user.tablesArray.map((table, index) => {
                      const tableNum = index + 1;
                      const isSelected = selectedTables.includes(
                        tableNum.toString()
                      );
                      const isCurrentTable =
                        tableNum === currentTableForSelection;
                      const disabled = isTableInOtherRange(table, index);
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (!disabled) toggleTableSelection(tableNum);
                          }}
                          style={{
                            padding: "10px",
                            margin: "5px 0",
                            borderRadius: 6,
                            cursor: disabled ? "not-allowed" : "pointer",
                            background: isSelected ? "#e3f2fd" : "#f8f9fa",
                            border: isSelected
                              ? "2px solid #2196f3"
                              : "1px solid #ddd",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            opacity: disabled ? 0.5 : 1,
                            transition: "all 0.2s",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            disabled={disabled}
                            onChange={() => {}}
                            style={{ margin: 0 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold" }}>
                              שולחן {tableNum}
                            </div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {table.title}
                            </div>
                          </div>
                          {isCurrentTable && (
                            <div
                              style={{
                                background: "#ff9800",
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: 12,
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              נוכחי
                            </div>
                          )}
                          {disabled && (
                            <span style={{ color: "red", fontSize: 12 }}>
                              שייך לטווח אחר
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    marginTop: 20,
                  }}
                >
                  <button
                    onClick={saveTableSelection}
                    style={{
                      background: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    שמור בחירה
                  </button>
                  <button
                    onClick={() => setShowTableSelectionModal(false)}
                    style={{
                      background: "#6c757d",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      flex: 1,
                    }}
                  >
                    ביטול
                  </button>
                </div>
              </div>
            )
          }
        />
      )}

      {/* פופאפ ניהול טווחים */}
      {showRangesModal && (
        <GenericModal
          init={() => setShowRangesModal(false)}
          div={<RangeManager user={user} hand={hand} />}
        />
      )}

      {showMoveGuestsModal && (
        <GenericModal
          init={() => setShowMoveGuestsModal(false)}
          div={
            <div
              style={{
                width: 400,
                background: "#fff",
                borderRadius: 10,
                padding: 24,
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
                העברת אורחים לשולחן אחר
              </div>
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{ marginBottom: 12, fontSize: 16, fontWeight: 600 }}
                >
                  הזן את מספר השולחן היעד:
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <input
                    type="number"
                    value={moveToTable}
                    onChange={(e) => setMoveToTable(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #ddd",
                      borderRadius: 4,
                      fontSize: 16,
                      width: 120,
                      textAlign: "center",
                    }}
                    min="1"
                    max={user.tablesArray.length}
                  />
                </div>
              </div>
              <div
                style={{ display: "flex", gap: 12, justifyContent: "center" }}
              >
                <button
                  onClick={handleMoveGuestsToTable}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  העבר
                </button>
                <button
                  onClick={() => setShowMoveGuestsModal(false)}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}

      {showSwapTablesModal && (
        <GenericModal
          init={() => setShowSwapTablesModal(false)}
          div={
            <div
              style={{
                width: 400,
                background: "#fff",
                borderRadius: 10,
                padding: 24,
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>
                החלפת אורחים בין שולחנות
              </div>
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{ marginBottom: 12, fontSize: 16, fontWeight: 600 }}
                >
                  הזן את מספרי השולחנות להחלפה:
                </div>
                <div
                  style={{ display: "flex", gap: 16, justifyContent: "center" }}
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 8,
                        fontSize: 14,
                      }}
                    >
                      שולחן ראשון:
                    </label>
                    <input
                      type="number"
                      value={swapTable1}
                      onChange={(e) => setSwapTable1(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        fontSize: 16,
                        width: 120,
                        textAlign: "center",
                      }}
                      min="1"
                      max={user.tablesArray.length}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      fontSize: 20,
                    }}
                  >
                    ↔
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 8,
                        fontSize: 14,
                      }}
                    >
                      שולחן שני:
                    </label>
                    <input
                      type="number"
                      value={swapTable2}
                      onChange={(e) => setSwapTable2(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        fontSize: 16,
                        width: 120,
                        textAlign: "center",
                      }}
                      min="1"
                      max={user.tablesArray.length}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ display: "flex", gap: 12, justifyContent: "center" }}
              >
                <button
                  onClick={handleSwapTables}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  החלף שולחנות
                </button>
                <button
                  onClick={() => {
                    setShowSwapTablesModal(false);
                    setSwapTable1("");
                    setSwapTable2("");
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}
      {showSaveSetModal && (
        <GenericModal
          init={() => {
            setShowSaveSetModal(false);
            setCustomSetName("");
          }}
          div={
            <div
              style={{
                background: "white",
                borderRadius: "12px",
                padding: "24px",
                minWidth: "400px",
                maxWidth: "500px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                <h3 style={{ margin: 0, color: "#333", fontSize: "18px" }}>
                  שמור מערך עזרים
                </h3>
                <p
                  style={{
                    margin: "8px 0 0 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  הזן שם למערך או השאר ריק לקבלת שם אוטומטי
                </p>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <input
                  type="text"
                  value={customSetName}
                  onChange={(e) => setCustomSetName(e.target.value)}
                  placeholder="שם המערך..."
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    outline: "none",
                    transition: "border-color 0.2s",
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      saveCurrentHelperSet();
                      setShowSaveSetModal(false);
                    }
                  }}
                  autoFocus
                />
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => {
                    saveCurrentHelperSet();
                    setShowSaveSetModal(false);
                  }}
                  style={{
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#218838";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#28a745";
                  }}
                >
                  שמור
                </button>
                <button
                  onClick={() => {
                    setShowSaveSetModal(false);
                    setCustomSetName("");
                  }}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#5a6268";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#6c757d";
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}
    </PopupDiv>
  );
};

// קומפוננטת טופס הוספת טווח
function AddRangeForm({
  user,
  hand,
  onCancel,
  initialNumbers = [],
  initialName = "",
  mainTable,
  isEdit,
}) {
  const [tablesInput, setTablesInput] = React.useState(
    initialNumbers.length > 0 ? initialNumbers.join(", ") : ""
  );
  const [rangeName, setRangeName] = React.useState(initialName);
  const [conflictAlert, setConflictAlert] = React.useState(null); // {conflictNumbers: [], conflictTitles: []}
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [successMsg, setSuccessMsg] = React.useState("");
  const dispatch = useDispatch();
  const [flag, setFlag] = React.useState(false); // לרענון

  // עוזר: מחזיר title של טווח עבור שולחן
  function getTableRangeTitle(tableNum) {
    const idx = parseInt(tableNum, 10) - 1;
    if (!user?.tablesArray?.[idx]) return null;
    const title = user.tablesArray[idx].title || "";
    if (title.startsWith("או") || title.startsWith("מתפרס עם")) return title;
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSuccessMsg("");
    setIsProcessing(false);
    // פרסור המספרים
    const numbers = tablesInput
      .split(/[,\s]+/)
      .map((n) => n.trim())
      .filter(Boolean)
      .map(Number)
      .filter((n) => !isNaN(n));
    if (numbers.length === 0) return;
    // אם עריכה - אל תאפשר לשנות את השולחן הראשי
    if (isEdit && mainTable && !numbers.includes(mainTable)) {
      setConflictAlert({
        conflictNumbers: [mainTable],
        conflictTitles: ["לא ניתן להסיר את השולחן הראשי מהטווח!"],
      });
      return;
    }
    // בדיקת קונפליקטים
    const conflicts = numbers
      .map((num) => ({
        num,
        range: getTableRangeTitle(num),
      }))
      .filter((x) => x.range && (!isEdit || !initialNumbers.includes(x.num)));
    if (conflicts.length > 0) {
      setConflictAlert({
        conflictNumbers: conflicts.map((c) => c.num),
        conflictTitles: conflicts.map((c) => c.range),
      });
      return;
    }
    // אין קונפליקטים - עדכן בפועל
    await applyRange(numbers, rangeName);
  }

  async function applyRange(numbers, rangeName) {
    setIsProcessing(true);
    const main = isEdit && mainTable ? mainTable : Math.min(...numbers);
    const others = numbers.filter((n) => n !== main);
    const updatedTables = user.tablesArray.map((t, idx) => {
      const tableNum = idx + 1;
      if (tableNum === main) {
        let title = others.length > 0 ? `או ${others.join(", ")}` : `${main}`;
        if (rangeName && rangeName.trim()) title += ` ${rangeName.trim()}`;
        return { ...t, title };
      }
      if (others.includes(tableNum)) {
        return { ...t, title: `מתפרס עם ${main}` };
      }
      // אם עריכה - ננקה את כל השולחנות שהיו בטווח הישן אבל לא בטווח החדש
      if (
        isEdit &&
        initialNumbers.includes(tableNum) &&
        !numbers.includes(tableNum)
      ) {
        return { ...t, title: "כללי" };
      }
      return t;
    });
    if (typeof dispatch === "function") {
      dispatch(
        editDetails({
          tablesArray: updatedTables,
          tables: user.tables,
        })
      ).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          // hand();
        } else toast.error(res.payload?.error);
      });
    }
    if (typeof hand === "function") hand();
    setIsProcessing(false);
    setSuccessMsg("הטווח נשמר בהצלחה!");
    setFlag((f) => !f);
    setTablesInput("");
    setRangeName("");
  }

  return (
    <>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          alignItems: "flex-end",
          marginBottom: 16,
          background: "#f4f4f4",
          borderRadius: 8,
          padding: 12,
        }}
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <label style={{ fontWeight: 700 }}>
          מספרי שולחנות (מופרדים בפסיק/רווח):
        </label>
        <input
          type="text"
          value={tablesInput}
          onChange={(e) => setTablesInput(e.target.value)}
          placeholder="למשל: 5, 7, 10"
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
        <label style={{ fontWeight: 700 }}>שם הטווח (אופציונלי):</label>
        <input
          type="text"
          value={rangeName}
          onChange={(e) => setRangeName(e.target.value)}
          placeholder="למשל: חברים חתן"
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
        <div
          style={{ display: "flex", gap: 8, marginTop: 8, alignSelf: "center" }}
        >
          <button
            type="submit"
            style={{
              background: "#007bff",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
            }}
            disabled={isProcessing}
          >
            {isProcessing ? "שומר..." : "שמור"}
          </button>
          <button
            type="button"
            style={{
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
            }}
            onClick={onCancel}
            disabled={isProcessing}
          >
            ביטול
          </button>
        </div>
        {successMsg && (
          <div style={{ color: "green", marginTop: 8 }}>{successMsg}</div>
        )}
      </form>
      {conflictAlert && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setConflictAlert(null)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 32,
              minWidth: 320,
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>
              לא ניתן להוסיף את הטווח:
            </div>
            <div style={{ color: "#dc3545", marginBottom: 16 }}>
              השולחנות הבאים כבר משויכים לטווח אחר:
              <br />
              <b>{conflictAlert.conflictNumbers.join(", ")}</b>
            </div>
            <div style={{ color: "#007bff", marginBottom: 16 }}>
              {conflictAlert.conflictTitles.map((t, i) => (
                <div key={i}>{t}</div>
              ))}
            </div>
            <div style={{ color: "#555", marginBottom: 16 }}>
              יש למחוק את הטווח הקודם לפני שניתן יהיה להוסיף את השולחן לטווח
              חדש.
            </div>
            <button
              style={{
                background: "#007bff",
                color: "white",
                border: "none",
                borderRadius: 4,
                padding: "8px 16px",
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => setConflictAlert(null)}
            >
              סגור
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default MainTables;
